<template>
  <div id="rewards" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_rewards.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.rewards") }}</span>
        <div class="page-des page-des-line-button">
          {{ $t("page.rewards_description") }}
        </div>
        <div class="button-title">
          <el-badge :value="badgeRedeemed" class="happily-primary">
            <el-button
              class="buttonRedeemed btn-gray-outline"
              style="color: #939393"
              @click="openRedeemed"
            >
              <div class="flex-mid">
                <img
                  :src="$utils('icons', 'bar_chart_gray_24dp')"
                  alt="icons_bar_chart_gray_24dp"
                  class="mb-3 mr-6"
                />
                {{ $t("rewards.Activity") }}
              </div>
            </el-button>
          </el-badge>
          <el-button
            class="buttonTitle"
            type="primary"
            @click="dialogFormReward = true"
            >{{ $t("rewards.add_a_reward") }}</el-button
          >
        </div>
      </div>
      <el-tabs class="style-bar" v-model="tab" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in tagMaster" :key="index" :name="index.toString()">
          <template #label>
          <span class="title-bar">
            {{ $t(`page.${item.value}`) }} 
            {{countNewReward[item.value]?`(${countNewReward[item.value]})`:''}}
          </span>
        </template>
          <div class="margin-subpages">
            <div class="flex-row-between">
              <el-input
                class="input-style"
                autosize
                :placeholder="$t('global.Search')"
                v-model="inputSearch"
                clearable
              ></el-input>
              <div style="display: flex; gap: 12px; align-items: center;">
                <div style="width: 200px">
                  <el-menu class="input-select" mode="horizontal">
                    <el-submenu index="0" style="width: 200px">
                      <template slot="title">
                        <span class="text-dropdown">{{ selectCountryFilterLabel }}</span>
                      </template>
                      <el-menu-item
                        @click="countryFilterClick('all')"
                        index="country-0"
                        style="font-size: 14px; width: 280px"
                        >{{ $t("rewards.all_countries_label") }}</el-menu-item
                      >
                      <el-menu-item
                        v-if="memberCountries.length > 0"
                        @click="countryFilterClick('members_only')"
                        index="country-1"
                        style="font-size: 14px; width: 280px"
                        >{{ $t("rewards.member_countries_only") }} ({{ memberCountries.length }})</el-menu-item
                      >
                      <el-menu-item
                        v-for="(country, idx) in catalogCountries"
                        :key="`country-${idx}`"
                        @click="countryFilterClick(country.value)"
                        :index="`country-${idx + 2}`"
                        style="font-size: 14px; width: 280px"
                        >{{ country.label }}</el-menu-item
                      >
                    </el-submenu>
                  </el-menu>
                </div>
                <div style="width: 200px">
                  <el-menu class="input-select" mode="horizontal">
                    <el-submenu index="0" style="width: 200px">
                      <template slot="title">
                        <span class="text-dropdown"
                          >{{ selectStatusLabel }} ({{
                            countrewards[status]
                              ? $utils("addCommasInNumber", countrewards[status])
                              : 0
                          }})</span
                        >
                      </template>
                      <el-menu-item
                        @click="statusClick('Active')"
                        index="1"
                        style="font-size: 14px; width: 220px"
                        >{{ $t("rewards.enabled") }} ({{
                          countrewards.Y ? countrewards.Y : 0
                        }})</el-menu-item
                      >
                      <el-menu-item
                        @click="statusClick('Inactive')"
                        index="2"
                        style="font-size: 14px; width: 220px"
                        >{{ $t("rewards.disabled") }} ({{
                          countrewards.N ? countrewards.N : 0
                        }})</el-menu-item
                      >
                      <el-menu-item
                        @click="statusClick('Show All')"
                        index="3"
                        style="font-size: 14px; width: 220px"
                        >{{ $t("rewards.show_all_status") }} ({{
                          countrewards.all ? countrewards.all : 0
                        }})</el-menu-item
                      >
                    </el-submenu>
                  </el-menu>
                </div>
                <a
                  v-if="tab === '0'"
                  href="#"
                  class="bulk-update-link"
                  @click.prevent="openBulkUpdateModal"
                >
                  <i class="el-icon-setting"></i> {{ $t("rewards.bulk_update_rates") }}
                </a>
              </div>
            </div>
            <div
              v-if="item.value === 'perks'"
              class="gem-exchange-banner"
              :class="{ 'is-enabled': gemExchangeEnabled, 'is-configured': gemExchangeEnabled && gemExchangeTierCount > 0 }"
            >
              <div class="geb-icon">
                <img src="../assets/images/ic_gem.png" alt="gem exchange" />
              </div>
              <div class="geb-copy">
                <div class="geb-title">
                  {{ $t("rewards.gem_exchange") }}
                  <span v-if="gemExchangeEnabled && gemExchangeTierCount > 0" class="geb-pill">
                    {{ gemExchangeTierCount }} {{ gemExchangeTierCount === 1 ? $t("rewards.tier_active") : $t("rewards.tiers_active") }}
                  </span>
                  <span v-else-if="gemExchangeEnabled" class="geb-pill geb-pill-warn">{{ $t("rewards.no_tiers_yet") }}</span>
                  <span v-else class="geb-pill geb-pill-muted">{{ $t("rewards.off") }}</span>
                </div>
                <div class="geb-sub" v-if="gemExchangeEnabled && gemExchangeTierCount > 0">
                  {{ gemExchangeSummary }}
                </div>
                <div class="geb-sub" v-else-if="gemExchangeEnabled">
                  {{ $t("rewards.gem_exchange_on_add_tiers") }}
                </div>
                <div class="geb-sub" v-else>
                  {{ $t("rewards.gem_exchange_intro") }}
                </div>
              </div>
              <el-button
                class="geb-cta"
                type="primary"
                plain
                @click="openGemExchangeEditor"
              >
                {{ gemExchangeEnabled && gemExchangeTierCount > 0 ? $t("rewards.edit_tiers") : (gemExchangeEnabled ? $t("rewards.configure_arrow") : $t("rewards.set_up_arrow")) }}
              </el-button>
            </div>
            <div class="line-style mt-32" />
            <div>
              <el-table
                :data="rewards"
                fixed
                :empty-text="
                  $utils('placeholderInTable', {
                    loadingLoop: loadingRewardsTable,
                    table: rewards.length,
                    textLoading: ' ',
                    textEmpty: 'No rewards',
                    textNotFound: 'No results found...',
                  })
                "
                ref="table2"
                style="width: 896px"
              >
                <el-table-column
                  class="headerCenter"
                  :label="$t('rewards.status')"
                  prop="block"
                  width="100"
                  min-width="50"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-switch
                      @change="handleBlock(scope.row)"
                      v-model="scope.row.block_status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="
                        scope.row.disabled && scope.row.disabled === 'Y'
                          ? true
                          : false
                      "
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column width="86">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.img"
                        v-lazy="scope.row.img"
                        class="img-rewards image-skeleton"
                        :style="scope.row.isExpired ? 'opacity: 0.5; filter: grayscale(50%);' : ''"
                      />
                      <div v-else class="divTitle" />
                      <div v-if="scope.row.isExpired" style="position: absolute; top: 25px;width: 56px;height: 19px; right: -6px;font-size: 11px;background-color: #909399; color: #fff; text-align: center;border-radius: 4px;display: flex;justify-content: center;"><span style="text-align: center;width: 100%;">{{ $t("rewards.expired_badge") }}</span></div>
                      <div v-else-if="!scope.row.oldreward?true:false" style="position: absolute; top: 25px;width: 44px;height: 19px; right: 0;font-size: 12px;background-color: #35D077; color: #fff; text-align: center;border-radius: 4px;display: flex;justify-content: center;"><span style="text-align: center;width: 100%;">{{ $t("rewards.new_badge") }}</span></div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="430"
                  :label="$t('rewards.Reward')"
                  prop="reward_en"
                  sortable
                >
                  <template slot-scope="scope">
                    <div class="fw-700 fs-16 fc-4A4A4A">
                      <span
                        v-if="scope.row.managed_by === 'gem_exchange'"
                        class="managed-badge"
                        :title="$t('rewards.managed_by_gem_exchange')"
                      >
                        <i class="el-icon-lock"></i> {{ $t("rewards.managed") }}
                      </span>
                      <span
                        v-if="scope.row.master_reward_id && scope.row.currency_variant === 'gems'"
                        class="linked-gem-badge"
                        :title="$t('rewards.linked_gem_variant.provider_linked')"
                      >
                        <i class="el-icon-link"></i> {{ $t("rewards.linked_gem_variant.gem_version") }}
                      </span>
                      {{ scope.row.reward_en }}
                    </div>
                    <div
                      style="color: #9d9d9d; width: 412px"
                      class="ellipsis fs-14"
                      :title="scope.row.description_en"
                    >
                      {{ scope.row.description_en }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.coins')"
                  prop="coins"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 16px; color: #4a4a4a; font-weight: 500">{{
                      $utils("addCommasInNumber", scope.row.coins)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.gems')"
                  prop="gems"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 16px; color: #4a4a4a; font-weight: 500">{{
                      $utils("addCommasInNumber", scope.row.gems)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.active')"
                  header-align="center"
                  width="100"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="editRewardNew(scope.$index, scope.row)"
                      class="buttonEdit btn-gray-outline"
                      type
                      >{{ $t("global.edit") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="!loadingRewardsTable"
              >
                <loading-even></loading-even>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane name="0">
          <span slot="label" class="title-bar">{{
            $t("page.gift_cards")
          }}</span>
          <div class="margin-subpages">
            <div class="flex-row-between">
              <el-input
                class="input-style"
                autosize
                :placeholder="$t('global.Search')"
                v-model="inputSearch"
                clearable
              ></el-input>
              <div style="width: 220px">
                <el-menu class="input-select" mode="horizontal">
                  <el-submenu index="0" style="width: 220px">
                    <template slot="title">
                      <span class="text-dropdown"
                          >{{ selectStatusLabel }} ({{
                          countrewards[status]
                            ? $utils("addCommasInNumber", countrewards[status])
                            : 0
                        }})</span
                      >
                    </template>
                    <el-menu-item
                      @click="statusClick('active')"
                      index="1"
                      style="font-size: 16px; width: 320px"
                      >{{ $t("rewards.add_a_reward") }} ({{
                        countrewards.Y ? countrewards.Y : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Inactive')"
                      index="2"
                      style="font-size: 16px; width: 320px"
                      >{{ $t("rewards.inactive") }} ({{
                        countrewards.N ? countrewards.N : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Show All')"
                      index="3"
                      style="font-size: 16px; width: 320px"
                      >{{ $t("rewards.show_all") }} ({{
                        countrewards.all ? countrewards.all : 0
                      }})</el-menu-item
                    >
                  </el-submenu>
                </el-menu>
              </div>
            </div>
            <div class="line-style mt-32" />
            <div>
              <el-table
                :data="rewards"
                fixed
                :empty-text="
                  $utils('placeholderInTable', {
                    loadingLoop: loadingRewardsTable,
                    table: rewards.length,
                    textLoading: ' ',
                    textEmpty: 'No rewards',
                    textNotFound: 'No results found...',
                  })
                "
                ref="table2"
                style="width: 896px"
              >
                <el-table-column
                  class="headerCenter"
                  :label="$t('rewards.status')"
                  prop="block"
                  width="100"
                  min-width="50"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-switch
                      @change="handleBlock(scope.row)"
                      v-model="scope.row.block_status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :disabled="
                        scope.row.disabled && scope.row.disabled === 'Y'
                          ? true
                          : false
                      "
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column width="86">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.img"
                        v-lazy="scope.row.img"
                        class="img-rewards image-skeleton"
                      />
                      <div v-else class="divTitle" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="430"
                  :label="$t('rewards.Reward')"
                  prop="reward_en"
                  sortable
                >
                  <template slot-scope="scope">
                    <div class="fw-700 fs-18 fc-4A4A4A">
                      {{ scope.row.reward_en }}
                    </div>
                    <div
                      style="color: #9d9d9d; width: 412px"
                      class="ellipsis fs-16"
                      :title="scope.row.description_en"
                    >
                      {{ scope.row.description_en }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.coins')"
                  prop="coins"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      $utils("addCommasInNumber", scope.row.coins)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.gems')"
                  prop="gems"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      $utils("addCommasInNumber", scope.row.gems)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.active')"
                  header-align="center"
                  width="100"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="editRewardNew(scope.$index, scope.row)"
                      class="buttonEdit btn-gray-outline"
                      type
                      >{{ $t("global.edit") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="!loadingRewardsTable"
              >
                <loading-even></loading-even>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label" class="title-bar">{{
            $t("page.perks")
          }}</span>
          <div class="margin-subpages">
            <div class="flex-row-between">
              <el-input
                class="input-style"
                autosize
                :placeholder="$t('global.Search')"
                v-model="inputSearch"
                clearable
              ></el-input>

              <div style="width: 220px">
                <el-menu class="input-select" mode="horizontal">
                  <el-submenu index="0" style="width: 220px">
                    <template slot="title">
                      <span class="text-dropdown"
                          >{{ selectStatusLabel }} ({{
                          countrewards[status]
                            ? $utils("addCommasInNumber", countrewards[status])
                            : 0
                        }})</span
                      >
                    </template>
                    <el-menu-item
                      @click="statusClick('Active')"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >{{ $t("rewards.active") }} ({{
                        countrewards.Y ? countrewards.Y : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Inactive')"
                      index="2"
                      style="font-size: 14px; width: 220px"
                      >{{ $t("rewards.inactive") }} ({{
                        countrewards.N ? countrewards.N : 0
                      }})</el-menu-item
                    >
                    <el-menu-item
                      @click="statusClick('Show All')"
                      index="3"
                      style="font-size: 14px; width: 220px"
                      >{{ $t("rewards.show_all") }} ({{
                        countrewards.all ? countrewards.all : 0
                      }})</el-menu-item
                    >
                  </el-submenu>
                </el-menu>
              </div>
            </div>
            <div class="line-style mt-32" />
            <div>
              <el-table
                :data="rewards"
                fixed
                :empty-text="
                  $utils('placeholderInTable', {
                    loadingLoop: loadingRewardsTable,
                    table: rewards.length,
                    textLoading: ' ',
                    textEmpty: 'No rewards',
                    textNotFound: 'No results found...',
                  })
                "
                ref="table"
                style="width: 896px"
              >
                <el-table-column
                  class="headerCenter"
                  :label="$t('rewards.status')"
                  prop="block"
                  width="100"
                  min-width="50"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-switch
                      @change="handleBlock(scope.row)"
                      v-model="scope.row.block_status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column width="86">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.img"
                        v-lazy="scope.row.img"
                        class="img-rewards image-skeleton"
                      />
                      <div v-else class="divTitle" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="450"
                  :label="$t('rewards.Reward')"
                  prop="reward_en"
                  sortable
                >
                  <template slot-scope="scope">
                    <div class="fw-700 fs-18 fc-4A4A4A">
                      {{ scope.row.reward_en }}
                    </div>
                    <div
                      style="color: #9d9d9d; width: 412px"
                      class="ellipsis fs-16"
                      :title="scope.row.description_en"
                    >
                      {{ scope.row.description_en }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="coins"
                  :label="$t('rewards.coins')"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      scope.row.coins
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="gems"
                  :label="$t('rewards.gems')"
                  width="80"
                  min-width="65"
                  align="center"
                  sortable
                >
                  <template slot-scope="scope">
                    <span style="font-size: 18px; color: #4a4a4a">{{
                      scope.row.gems
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('rewards.active')"
                  header-align="center"
                  width="100"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      class="buttonEdit btn-gray-outline"
                      type
                      @click="editRewardNew(scope.$index, scope.row)"
                      >{{ $t("global.edit") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="center mt-20 mb-40 pt-20 pb-40"
                v-if="!loadingRewardsTable"
              >
                <loading-even></loading-even>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
      </el-tabs>
    </div>

    <div id="reward_form_modal">
      <el-dialog
        :visible.sync="dialogFormReward"
        width="1008px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="rw-modal"
        @close="cancelReward"
      >
        <div class="grid-2-section">
          <div class="grid-left">
            <div class="header flex-center">
              <img
                :src="$utils('icons', 'ic_preview')"
                style="height: 24px; margin-top: -2px"
                class="mr-12"
              />
              <span>{{ $t("rewards.preview_on_mobile") }}</span>
            </div>
            <div class="body">
              <div class="image-container">
                <div class="image-box flex-mid" style="position: relative">
                  <img
                    v-if="imageUrl"
                    v-lazy="imageUrl"
                    class="avatar image-skeleton"
                  />
                  <div
                    v-else
                    class="flex-mid"
                    style="width: 192px; height: 192px"
                  >
                    <img
                      src="../assets/images/uploadimg@2x.png"
                      class="avatar-uploader-icon"
                    />
                  </div>
                  <div
                    class="absolute-mid"
                    style="
                      width: 191px;
                      height: 191px;
                      background-color: #00ebff65;
                      border: 1px solid #00f5ff;
                    "
                  ></div>
                </div>
              </div>
              <div class="thin-scrollbar details" style="height: 335px">
                <div>
                  <div
                    v-if="!$utils('watchingTrim', ruleFormReward.names.en || '')"
                    class="bg-000000 bd-r-4 opa-03"
                    style="width: 154px; height: 18px"
                  ></div>
                  <div v-else class="fs-20 fw-900 fc-000000">
                    {{ ruleFormReward.names.en }}
                  </div>
                  <div
                    v-if="
                      !$utils(
                        'watchingTrim',
                        ruleFormReward.descriptions.en || ''
                      )
                    "
                    class="mt-6"
                  >
                    <div
                      class="bg-000000 bd-r-4 opa-01"
                      style="height: 18px"
                    ></div>
                    <div
                      class="bg-000000 bd-r-4 opa-01 mt-2"
                      style="height: 18px"
                    ></div>
                    <div
                      class="bg-000000 bd-r-4 opa-01 mt-2"
                      style="width: 180px; height: 18px"
                    ></div>
                  </div>
                  <div v-else class="fs-16 fw-400 fc-6C6C6C pre-line mt-6">
                    {{ ruleFormReward.descriptions.en }}
                  </div>
                </div>
                <div class="mt-30 flex-center" style="margin-top: 36px">
                  <div class="button-take-reward flex-mid">
                    <i class="el-icon-minus"></i>
                  </div>
                  <div class="opa-08 fs-20 mx-16">1</div>
                  <div class="button-take-reward flex-mid">
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <div
                  class="flex mb-26"
                  :style="`margin-top: ${
                    ruleFormReward.description_en ? '50' : '99'
                  }px;`"
                >
                  <div>
                    <div class="button-cencel-redeem flex-mid">
                      <i class="el-icon-close"></i>
                    </div>
                  </div>
                  <div>
                    <div class="button-redeem flex-mid cursor-default">
                      <div v-if="ruleFormReward.approval">
                        {{ $t("rewards.REQUEST") }}
                      </div>
                      <div v-else>{{ $t("rewards.REDEEM") }}</div>
                      <div class="mock flex-center">
                        <img
                          v-if="ruleFormReward.costSelected == 'coins'"
                          class="coin"
                          src="../assets/icons/ic_flat_coin.png"
                        />
                        <img
                          v-else
                          src="../assets/icons/ic_flat_gem.png"
                          class="coin"
                        />
                        <div
                          v-if="
                            $utils('watchingTrim', ruleFormReward.cost || '')
                          "
                          class="fs-18 fw-700 mt-2 ml-6"
                        >
                          {{ ruleFormReward.cost }}
                        </div>
                        <div
                          v-else
                          class="bg-FFFFFF opa-05 bd-r-4 ml-8"
                          style="width: 30px; height: 20px"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right fc-000000">
            <div class="fs-20 fw-700">
              {{ dialogFormRewardRule === "edit" ? $t("rewards.edit_a_reward") : $t("rewards.add_a_reward") }}
            </div>
            <el-form
              :model="ruleFormReward"
              :rules="rules"
              ref="ruleForm"
              label-width="200px"
              class="demo-ruleForm"
            >
              <el-menu
                style="margin-top: 20px;margin-left: 146px; border-bottom: solid 2px #e6e6e6"
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
              >
              <el-menu-item
              v-for="(item, index) in language"
                :key="index"
                :index="item.code" 
                style="padding-left: 0" >
                {{
                  item.text
                }}
              </el-menu-item>



                <!-- <el-menu-item style="padding-left: 0" index="1">{{
                  $t("rewards.english")
                }}</el-menu-item>
                <el-menu-item index="2" v-if="!engonly">{{
                  $t("rewards.thai")
                }}</el-menu-item> -->
              </el-menu>


              <div
              class="mt-24"
              style="margin-left: -55px"
              >
              <el-form-item :prop="`names.${activeIndex}`">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.name")
                  }}</span>
                  <el-input
                    v-model="ruleFormReward.names[activeIndex]"
                    class="dialogInput"
                    auto-complete="off"
                    :placeholder="$t('rewards.name_of_reward')"
                    required
                    :disabled="ruleFormReward.master"
                    @input="onInputNameEn"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="dialogLabel"
                    ><span class="fc-F56C6C mr-4">*</span
                    >{{ $t("rewards.description") }}</span
                  >
                  <el-input
                    type="textarea"
                    v-model="ruleFormReward.descriptions[activeIndex]"
                    class="dialogInput"
                    :placeholder="$t('rewards.description')"
                    required
                    :disabled="ruleFormReward.master"
                    rows="4"
                    @input="onInputDescEn"
                  ></el-input>
                </el-form-item>

              </div>
              




              <!-- <div
                v-if="activeIndex == '0'"
                class="mt-24"
                style="margin-left: -55px"
              >
                <el-form-item prop="name">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.name")
                  }}</span>
                  <el-input
                    v-model="ruleFormReward.name_en"
                    class="dialogInput"
                    auto-complete="off"
                    :placeholder="$t('rewards.name_of_reward')"
                    required
                    :disabled="ruleFormReward.master"
                    @input="onInputNameEn"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="dialogLabel"
                    ><span class="fc-F56C6C mr-4">*</span
                    >{{ $t("rewards.description") }}</span
                  >
                  <el-input
                    type="textarea"
                    v-model="ruleFormReward.description_en"
                    class="dialogInput"
                    :placeholder="$t('rewards.description')"
                    required
                    :disabled="ruleFormReward.master"
                    rows="4"
                    @input="onInputDescEn"
                  ></el-input>
                </el-form-item>
              </div>
              <div
                v-if="activeIndex == '1'"
                class="mt-24"
                style="margin-left: -55px"
              >
                <el-form-item prop="name">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.name")
                  }}</span>
                  <el-input
                    v-model="ruleFormReward.name"
                    class="dialogInput"
                    auto-complete="off"
                    :placeholder="$t('rewards.mame_of_reward_Thai')"
                    required
                    :disabled="ruleFormReward.master"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="dialogLabel"
                    ><span class="fc-F56C6C">*</span>
                    {{ $t("rewards.description") }}</span
                  >
                  <el-input
                    type="textarea"
                    v-model="ruleFormReward.description"
                    class="dialogInput"
                    required
                    :placeholder="$t('rewards.description_Thai')"
                    rows="4"
                    :disabled="ruleFormReward.master"
                  ></el-input>
                </el-form-item>
              </div> -->





              <div style="margin-left: -55px">
                <el-form-item prop="cost">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.cost")
                  }}</span>
                  <el-col :span="14">
                    <el-input
                      type="number"
                      :min="0"
                      v-model="ruleFormReward.cost"
                      @blur="checkCost"
                      auto-complete="off"
                      placeholder="0"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="10">
                    <div class="ml-12">
                      <el-select
                        v-model="ruleFormReward.costSelected"
                        :disabled="ruleFormReward.master"
                      >
                        <el-option
                          :label="$t('rewards.coins')"
                          value="coins"
                        ></el-option>
                        <el-option
                          :label="$t('rewards.gems')"
                          value="gems"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <div
                    v-if="ruleFormReward.master && !ruleFormReward.linkedVariant && ruleFormReward.costSelected === 'coins'"
                    class="linked-gem-entry"
                  >
                    <button type="button" class="linked-gem-entry-button" @click="openLinkedGemVariant">
                      <img src="../assets/icons/ic_flat_gem.png" alt="" />
                      <span>
                        <strong>{{ linkedGemExistingVariant ? $t("rewards.linked_gem_variant.edit_action") : $t("rewards.linked_gem_variant.add_action") }}</strong>
                        <small>{{ $t("rewards.linked_gem_variant.keep_coin_help") }}</small>
                      </span>
                      <i class="el-icon-arrow-right"></i>
                    </button>
                  </div>
                </el-form-item>
                <el-form-item prop="duration">
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.duration")
                  }}</span>
                  <el-date-picker
                    class="dialogInput"
                    v-model="ruleFormReward.duration"
                    type="daterange"
                    format="dd/MM/yyyy HH:mm"
                    range-separator="TO"
                    :start-placeholder="$t('rewards.start_date')"
                    :end-placeholder="$t('rewards.end_date')"
                    :disabled="ruleFormReward.master"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.settings")
                  }}</span>
                  <el-col :span="12">
                    <el-select
                      v-model="ruleFormReward.type"
                      :placeholder="$t('rewards.type_placeholder')"
                      :disabled="ruleFormReward.master"
                    >
                    <el-option v-for="(item,index) in tagMaster" :key="index"
                        :label="$t(`rewards.${item.value}`)"
                        :value="index.toString()"
                      ></el-option>
                      <!-- <el-option
                        :label="$t('rewards.gift_cards')"
                        value="0"
                      ></el-option>
                      <el-option
                        :label="$t('rewards.perks')"
                        value="3"
                      ></el-option>
                      <el-option
                        :label="$t('rewards.team_building')"
                        value="team_building"
                      ></el-option>
                      <el-option
                        :label="$t('rewards.doing_good')"
                        value="doing_good"
                      ></el-option> -->
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <div class="ml-12">
                      <el-select
                        v-model="ruleFormReward.country"
                        :placeholder="$t('rewards.country')"
                        :disabled="ruleFormReward.master"
                      >
                        <el-option
                          :label="$t('rewards.all_countries')"
                          value="All Countries"
                        ></el-option>
                        <el-option
                          v-for="item in optionsCountry"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.limit_quantity")
                  }}</span>
                  <div class="limit-mode-block">
                    <div class="limit-mode-picker" role="tablist">
                      <button
                        type="button"
                        role="tab"
                        class="limit-mode-pill"
                        :class="{ 'is-active': ruleFormReward.limitMode === 'unlimited' }"
                        :aria-selected="ruleFormReward.limitMode === 'unlimited'"
                        @click="setLimitMode('unlimited')"
                      >
                        {{ $t("rewards.limit_unlimited") }}
                      </button>
                      <button
                        type="button"
                        role="tab"
                        class="limit-mode-pill"
                        :class="{ 'is-active': ruleFormReward.limitMode === 'total' }"
                        :aria-selected="ruleFormReward.limitMode === 'total'"
                        @click="setLimitMode('total')"
                      >
                        {{ $t("rewards.limit_total") }}
                      </button>
                      <button
                        type="button"
                        role="tab"
                        class="limit-mode-pill"
                        :class="{ 'is-active': ruleFormReward.limitMode === 'monthly' }"
                        :aria-selected="ruleFormReward.limitMode === 'monthly'"
                        @click="setLimitMode('monthly')"
                      >
                        {{ $t("rewards.limit_monthly") }}
                      </button>
                    </div>
                    <transition name="limit-fade">
                      <div
                        v-if="ruleFormReward.limitMode !== 'unlimited'"
                        class="limit-value-row"
                      >
                        <div class="limit-value-display">
                          <span class="limit-value-num">{{ ruleFormReward.limitValue || 0 }}</span>
                          <span class="limit-value-unit">{{ limitValueUnit }}</span>
                        </div>
                        <div class="limit-value-controls">
                          <div
                            @mousedown="startHoldLimit(1)"
                            @touchstart="startHoldLimit(1)"
                            @mouseleave="stopHoldLimit"
                            @mouseup="stopHoldLimit"
                            @touchend="stopHoldLimit"
                            @touchcancel="stopHoldLimit"
                            class="cursor-pointer button-quantity center mr-12"
                          >
                            <i class="el-icon-plus"></i>
                          </div>
                          <div
                            @mousedown="startHoldLimit(-1)"
                            @touchstart="startHoldLimit(-1)"
                            @mouseleave="stopHoldLimit"
                            @mouseup="stopHoldLimit"
                            @touchend="stopHoldLimit"
                            @touchcancel="stopHoldLimit"
                            class="cursor-pointer button-quantity center"
                          >
                            <i class="el-icon-minus"></i>
                          </div>
                        </div>
                      </div>
                    </transition>
                    <div
                      v-if="ruleFormReward.limitMode !== 'unlimited'"
                      class="limit-helper-text"
                    >
                      <i
                        class="el-icon-info limit-helper-icon"
                        v-if="ruleFormReward.limitMode === 'monthly'"
                      ></i>
                      <span>{{ limitHelperText }}</span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.Require_Approval")
                  }}</span>
                  <div class="flex-center">
                    <div
                      class="relative switch-contrainer-small"
                      :class="{ 'border-blue': ruleFormReward.approval }"
                    >
                      <input
                        type="checkbox"
                        id="checkboxApproval"
                        class="input-checkbox"
                        v-model="ruleFormReward.approval"
                      />
                      <label for="checkboxApproval" class="lable-checkbox">{{
                        ruleFormReward.approval
                      }}</label>
                    </div>
                    <div class="fs-16 fc-4A4A4A ml-16">
                      <span v-if="ruleFormReward.approval">
                        {{ $t("rewards.On") }}
                      </span>
                      <span v-else>
                        {{ $t("rewards.Off") }}
                      </span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item>
                  <span slot="label" class="dialogLabel">{{
                    $t("rewards.image")
                  }}</span>
                  <div class="flex-center">
                    <el-upload
                      action
                      :http-request="addImage"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUpload"
                    >
                      <div
                        class="button-upload flex-mid"
                        :class="`${
                          ruleFormReward.master ? 'button-disable' : ''
                        }`"
                      >
                        {{ $t("rewards.upload") }}
                      </div>
                    </el-upload>
                    <div class="ml-16">
                      <div
                        class="fs-12 fc-000000"
                        style="line-height: 14px; word-break: break-word"
                      >
                        {{ $t("rewards.file_size_should") }}
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </el-form>

            <div style="margin-left: 145px" class="mt-32">
              <span slot="footer">
                <el-button
                  v-if="dialogFormRewardRule == 'edit'"
                  class="btn-add bigger"
                  type="primary"
                  @click="submitReward('edit')"
                  >{{ $t("global.SAVE") }}</el-button
                >
                <el-button
                  v-else
                  class="btn-add bigger"
                  type="primary"
                  @click="submitReward('add')"
                  >{{ $t("global.ADD") }}</el-button
                >
                <el-button class="btn-cancel bigger" @click="clearRewardFrom">{{
                  $t("global.CANCEL")
                }}</el-button>
                <el-button
                  v-if="
                    dialogFormRewardRule == 'edit' &&
                    ruleFormReward.master == false
                  "
                  class="btnDeleteDialog bigger"
                  type="danger"
                  @click="deleteReward"
                  >{{ $t("global.DELETE") }}</el-button
                >
              </span>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <el-dialog
      :visible.sync="dialogFormRedeemed"
      width="calc(100vw - 64px)"
      top="24px"
      custom-class="ra-modal"
      :close-on-click-modal="false"
    >
      <span slot="title"></span>
      <div
        class="ra-modal-shell"
        :aria-busy="rewardActivityLoading ? 'true' : 'false'"
      >
        <div
          v-if="rewardActivityLoading"
          class="ra-loading-state"
          role="status"
          aria-live="polite"
        >
          <div class="ra-loading-message">
            <i class="el-icon-loading" aria-hidden="true"></i>
            <div>
              <div class="ra-loading-title">{{ $t("rewards.loading_activity") }}</div>
              <div class="ra-loading-hint">{{ $t("rewards.loading_activity_hint") }}</div>
            </div>
          </div>
          <div class="ra-loading-preview" aria-hidden="true">
            <div class="ra-loading-summary">
              <span class="ra-skeleton ra-skeleton-heading"></span>
              <div class="ra-loading-stat-group">
                <span v-for="item in 3" :key="`loading-stat-${item}`" class="ra-skeleton ra-skeleton-stat"></span>
              </div>
            </div>
            <div class="ra-loading-chart">
              <span v-for="bar in 13" :key="`loading-bar-${bar}`" class="ra-skeleton ra-skeleton-bar"></span>
            </div>
            <div class="ra-loading-toolbar">
              <span class="ra-skeleton ra-skeleton-control"></span>
              <span class="ra-skeleton ra-skeleton-toggle"></span>
            </div>
            <div class="ra-loading-table">
              <div v-for="row in 7" :key="`loading-row-${row}`" class="ra-loading-row">
                <span v-for="cell in 5" :key="`loading-cell-${row}-${cell}`" class="ra-skeleton"></span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="rewardActivityError"
          class="ra-error-state"
          role="alert"
        >
          <i class="el-icon-warning-outline" aria-hidden="true"></i>
          <div class="ra-error-title">{{ $t("rewards.activity_load_error") }}</div>
          <div class="ra-error-hint">{{ $t("rewards.activity_load_error_hint") }}</div>
          <el-button type="primary" @click="retryRewardActivity">
            {{ $t("global.try_again") }}
          </el-button>
        </div>
        <div v-else class="ra-modal-content">
        <div class="ra-hero">
          <div class="ra-hero-head">
            <div>
              <div class="ra-eyebrow">{{ $t("rewards.reward_activity") }}</div>
              <div class="ra-hero-title">{{ rewardActivityHeroValue }}</div>
              <div class="ra-hero-meta">
                <div class="ra-hero-sub">{{ rewardActivityHeroSub }}</div>
                <div
                  v-if="rewardActivityRefreshing"
                  class="ra-refreshing"
                  role="status"
                  aria-live="polite"
                >
                  <i class="el-icon-loading" aria-hidden="true"></i>
                  <span>{{ $t("rewards.updating_activity") }}</span>
                </div>
              </div>
            </div>
            <div class="ra-hero-stats">
              <div class="ra-stat">
                <div class="ra-stat-label">{{ $t("rewards.delivered") }}</div>
                <div class="ra-stat-value">{{ rewardActivityStats.delivered }}</div>
              </div>
              <div class="ra-stat">
                <div class="ra-stat-label">{{ $t("rewards.members") }}</div>
                <div class="ra-stat-value">{{ rewardActivityStats.members }}</div>
              </div>
              <div class="ra-stat">
                <div class="ra-stat-label">{{ $t("rewards.pending") }}</div>
                <div class="ra-stat-value">{{ rewardActivityStats.pending }}</div>
              </div>
            </div>
          </div>
          <div class="ra-chart-wrap">
            <canvas
              ref="rewardActivityBarchart"
              height="180px"
              class="barchart-style"
            ></canvas>
          </div>
        </div>
        <div class="ra-toolbar">
          <div class="ra-month-picker">
            <el-menu class="input-select" mode="horizontal">
              <el-submenu index="1">
                <template slot="title">
                  <span class="text-dropdown">{{ selectMonth ? selectMonth : start_month }}</span>
                </template>
                <div class="scroll-style thin-scrollbar">
                  <el-menu-item
                    v-bind:key="index"
                    v-for="(item, index) in list_month"
                    index="1"
                    @click="monthClick(item.num_month, item.label_month)"
                    >{{ item.label_month }}</el-menu-item
                  >
                  <el-menu-item
                    index="1"
                    @click="monthClick('custom', $t('rewards.custom_date_range'))"
                    >{{ $t("rewards.custom_date_range") }}</el-menu-item
                  >
                </div>
              </el-submenu>
            </el-menu>
          </div>
          <el-radio-group
            v-model="rewardActivityView"
            class="ra-view-toggle"
            size="small"
            :aria-label="$t('rewards.reward_activity_view')"
          >
            <el-radio-button label="transactions">{{ $t("rewards.transactions") }}</el-radio-button>
            <el-radio-button label="members">{{ $t("rewards.member_spend") }}</el-radio-button>
          </el-radio-group>
          <div @click="exportTable" class="ra-export-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            <span>{{ $t("rewards.export") }}</span>
          </div>
        </div>
        <div class="ra-table-wrap thin-scrollbar">
          <el-table
            v-if="rewardActivityView === 'transactions'"
            id="redeemedTable"
            :data="redeemed"
            :default-sort="{ prop: 'name', order: 'ascending' }"
            size="small"
            :max-height="rewardTableMaxHeight"
            :empty-text="$t('rewards.activity_empty')"
          >
            <el-table-column
              prop="reward"
              :label="$t('rewards.Reward')"
              height="10px"
              min-width="170"
            >
              <template slot-scope="scope">
                <div class="flex-center fc-000000">
                  <span class="fs-14 fw-500 ellipsis">{{
                    scope.row.reward
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="user"
              :label="$t('rewards.redeemed_by_member')"
              min-width="220"
            >
              <template slot-scope="scope">
                <div class="recipient-user-box flex-center" :class="{ 'blurelement': blurMode }">
                  <img
                    v-if="scope.row.user_pic"
                    v-lazy="scope.row.user_pic"
                    :key="scope.row.user_pic"
                    class="image-skeleton image-profile-32 flex-mid"
                  />
                  <div v-else class="image image-profile-32 flex-mid bg-primary-light">
                    <div class="text-in-image text-in-image-32 flex-mid fc-primary">
                      {{ $utils("acronymName", { fullName: scope.row.user }) }}
                    </div>
                  </div>
                  <div class="ml-8 fc-000000" style="line-height: 16px; min-width: 0">
                    <div class="fs-14 fw-500 ellipsis">{{ scope.row.user }}</div>
                    <div class="fs-13 opa-06 ellipsis">{{ scope.row.email }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="send_to"
              :label="$t('rewards.Recipient')"
              min-width="220"
            >
              <template slot-scope="scope">
                <!-- <div class="flex-center">
                  <span
                    class
                    style="
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                    >{{ scope.row.user
                    }}{{
                      scope.row.send_to != ""
                        ? " (" + scope.row.send_to + ")"
                        : ""
                    }}</span
                  >
                </div> -->
                <div class="flex-row-between">
                  <div class="recipient-user-box flex-center"
                  :class="{ 'blurelement': blurMode }">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-32 flex-mid"
                    />
                    <div v-else class="image image-profile-32 flex-mid bg-primary-light">
                      <div class="text-in-image text-in-image-32 flex-mid fc-primary">
                        {{
                          $utils("acronymName", {
                            fullName: scope.row.send_to,
                          })
                        }}
                      </div>
                    </div>
                    <div class="ml-8 fc-000000" style="line-height: 16px">
                      <div class="fs-14 fw-500 ellipsis" style="max-width: 200px;">{{ scope.row.send_to }}</div>
                      <div class="fs-13 opa-06 ellipsis" style="max-width: 200px;">{{ scope.row.team }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="email"
              header-align="right"
              align="right"
              :label="$t('rewards.value')"
              min-width="100"
            >
              <template slot-scope="scope">
                <div class="flex-center right fc-000000">
                  <div
                    class="fs-14 fw-500 ellipsis ml-auto"
                    style="white-space: nowrap"
                  >
                    {{ scope.row.symbol+scope.row.value }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="date"
              header-align="right"
              align="right"
              :label="$t('rewards.date_and_time')"
              min-width="180"
            >
              <template slot-scope="scope">
                <div class="flex-center fc-000000">
                  <div class="fs-14 fw-500 ellipsis ml-auto">
                    {{ scope.row.date }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              :label="$t('rewards.status')"
              min-width="140"
            >
              <template slot-scope="scope">
                <div class="flex-center" style="width: 110px">
                  <div class="mr-auto">
                    <span
                      class="span-status-tag tag-processing"
                      v-if="scope.row.status == 'N'"
                    >
                      {{ $t("rewards.processing") }}
                    </span>
                    <span
                      class="span-status-tag tag-processing"
                      v-if="scope.row.status == 'P'"
                    >
                      {{ $t("rewards.processing") }}
                    </span>
                    <span
                      class="span-status-tag tag-delivered"
                      v-if="scope.row.status == 'Y' || scope.row.status_send == 'SC'"
                    >
                      {{ $t("rewards.Delivered") }}
                    </span>
                    <span
                      class="span-status-tag tag-cancel"
                      v-if="scope.row.status == 'X'"
                    >
                      {{ $t("rewards.cancel") }}
                    </span>
                    <span
                      class="span-status-tag tag-refund"
                      v-if="scope.row.status == 'C'"
                    >
                      {{ $t("rewards.refund") }}
                    </span>
                  </div>
                  <el-dropdown v-if="scope.row.check_rewards_company" :disabled="scope.row.check_disable">
                    <span class="el-dropdown-link">
                      <img
                        :src="$utils('icons', 'edit_black_24dp')"
                        alt="icons_edit_black_24dp"
                        :class="{ 'opa-02': scope.row.check_disable }"
                      />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="scope.row.status != 'P'"
                        ><div @click="redeemedClick(scope.row, 'P')">
                          {{ $t("rewards.processing") }}
                        </div></el-dropdown-item
                      >
                      <el-dropdown-item v-if="scope.row.status != 'Y'"
                        ><div @click="redeemedClick(scope.row, 'Y')">
                          {{ $t("rewards.sent") }}
                        </div></el-dropdown-item
                      ><el-dropdown-item v-if="scope.row.status != 'X'"
                        ><div @click="redeemedClick(scope.row, 'X')">
                          {{ $t("rewards.cancel") }}
                        </div></el-dropdown-item
                      ><el-dropdown-item v-if="scope.row.status != 'C'"
                        ><div @click="redeemedClick(scope.row, 'C')">
                          {{ $t("rewards.refund") }}
                        </div></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown v-else :disabled="scope.row.check_disable">
                    <span class="el-dropdown-link">
                      <img
                        :src="$utils('icons', 'edit_black_24dp')"
                        alt="icons_edit_black_24dp"
                        :class="{ 'opa-02': scope.row.check_disable }"
                      />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="scope.row.status != 'X'"
                        ><div @click="redeemedClick(scope.row, 'X')">
                          {{ $t("rewards.cancel") }}
                        </div></el-dropdown-item
                      ><el-dropdown-item v-if="scope.row.status != 'C'"
                        ><div @click="redeemedClick(scope.row, 'C')">
                          {{ $t("rewards.refund") }}
                        </div></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <el-menu
                    :default-active="activeIndex"
                    mode="horizontal"
                    close="ml-auto"
                    id="hide-arrow-menu"
                    style="border-bottom: none"
                  >
                    <el-submenu
                      index="1"
                      v-bind:disabled="scope.row.check_disable"
                    >
                      <template slot="title">
                        <span>
                          <img
                            :src="$utils('icons', 'edit_black_24dp')"
                            alt="icons_edit_black_24dp"
                          />
                        </span>
                      </template>
                      <el-menu-item
                        index="1-2"
                        v-if="scope.row.status != 'P'"
                        @click="redeemedClick(scope.row.id, 'P')"
                        >{{ $t("rewards.processing") }}</el-menu-item
                      >
                      <el-menu-item
                        index="1-3"
                        v-if="scope.row.status != 'Y'"
                        @click="redeemedClick(scope.row.id, 'Y')"
                        >{{ $t("rewards.sent") }}</el-menu-item
                      >
                      <el-menu-item
                        index="1-4"
                        v-if="scope.row.status != 'X'"
                        @click="redeemedClick(scope.row.id, 'X')"
                        >{{ $t("rewards.cancel") }}</el-menu-item
                      >
                    </el-submenu>
                  </el-menu> -->
                </div>
              </template>
            </el-table-column>
            <template slot="append">
              <div v-show="loadmore_ck">
                <infinite-loading
                  :on-infinite="loadmore"
                  force-use-infinite-wrapper=".el-table__body-wrapper"
                >
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                </infinite-loading>
              </div>
            </template>
          </el-table>
          <div v-else class="ra-member-spend">
            <div class="ra-member-spend-intro">
              <div>
                <div class="ra-member-spend-title">{{ $t("rewards.member_spend") }}</div>
                <div class="ra-member-spend-hint">{{ $t("rewards.member_spend_hint") }}</div>
              </div>
              <div v-if="rewardActivityCurrencyTotals.length > 1" class="ra-currency-note">
                {{ $t("rewards.currency_totals_separate") }}
              </div>
            </div>
            <el-table
              id="memberSpendTable"
              :data="memberRewardSpend"
              size="small"
              :max-height="rewardTableMaxHeight"
              :empty-text="$t('rewards.member_spend_empty')"
            >
              <el-table-column prop="name" :label="$t('rewards.member')" min-width="280">
                <template slot-scope="scope">
                  <div class="recipient-user-box flex-center" :class="{ 'blurelement': blurMode }">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-32 flex-mid"
                    />
                    <div v-else class="image image-profile-32 flex-mid bg-primary-light">
                      <div class="text-in-image text-in-image-32 flex-mid fc-primary">
                        {{ $utils("acronymName", { fullName: scope.row.name }) }}
                      </div>
                    </div>
                    <div class="ml-8 fc-000000" style="line-height: 16px; min-width: 0">
                      <div class="fs-14 fw-500 ellipsis">{{ scope.row.name }}</div>
                      <div class="fs-13 opa-06 ellipsis">{{ scope.row.team || scope.row.email }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="currency" :label="$t('rewards.currency')" min-width="110" />
              <el-table-column
                prop="redemptions"
                :label="$t('rewards.redemptions')"
                header-align="right"
                align="right"
                min-width="125"
              />
              <el-table-column
                prop="amount"
                :label="$t('rewards.reward_spend')"
                header-align="right"
                align="right"
                min-width="170"
              >
                <template slot-scope="scope">
                  <span class="fs-14 fw-700">{{ formatRewardActivityAmount(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="share" :label="$t('rewards.share_of_currency_spend')" min-width="260">
                <template slot-scope="scope">
                  <div class="ra-share-cell">
                    <div class="ra-share-track" aria-hidden="true">
                      <div class="ra-share-fill" :style="{ width: `${Math.min(scope.row.share, 100)}%` }"></div>
                    </div>
                    <span>{{ formatRewardActivityShare(scope.row.share) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="lastActivityRaw"
                :label="$t('rewards.last_activity')"
                header-align="right"
                align="right"
                min-width="210"
              >
                <template slot-scope="scope">
                  <span class="fs-13 fw-500 ra-last-activity">{{ scope.row.lastActivity }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        </div>
      </div>
      <span slot="footer">
        <!-- <el-button
          @click="dialogFormRedeemed = false"
          style="
            margin-right: 26px;
            color: #939393;
            margin-top: 8px;
            font-weight: bold;
            width: 86px;
          "
          >{{ $t("global.close") }}</el-button
        > -->
      </span>
    </el-dialog>

    <el-dialog id="customDateRangeDialog" :visible.sync="showCustomDateDialog" width="530px">
      <div style="padding: 24px 32px 32px 32px;">
        <div class="fc-4A4A4A fs-16 fw-700" style="margin-bottom: 24px;">
          {{ $t("rewards.date_range") }}
        </div>
        <div style="display: flex; justify-content: center; margin-bottom: 32px;">
          <el-date-picker
            v-model="customDateRange"
            type="daterange"
            unlink-panels
            :range-separator="$t('rewards.to')"
            align="center"
            :start-placeholder="$t('rewards.start_date_placeholder')"
            :end-placeholder="$t('rewards.end_date_placeholder')"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="large"
          />
        </div>
        <div style="display: flex; justify-content: flex-end; gap: 16px;">
          <div class="btn-gray flex-mid cursor-pointer" style="min-width: 100px; height: 40px; padding: 0 24px; border-radius: 8px; font-size: 14px; font-weight: 700;" @click.prevent="closeCustomDateDialog">
            {{ $t("global.CANCEL") }}
          </div>
          <div class="btn-add flex-mid cursor-pointer" style="min-width: 140px; height: 40px; padding: 0 24px; border-radius: 8px; font-size: 14px; font-weight: 700; white-space: nowrap;" @click="handleCustomDateConfirm">
            {{ $t("rewards.confirm_and_filter") }}
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="statusConfirmModal" width="600px">
      <div class="fc-000000">
        <div class="m-20 pt-40 fs-20 fw-700">
          <i class="el-icon-warning" style="color: orange"></i>
          {{ $t("rewards.confirm_cancellation") }}
        </div>
        <div class="mx-20 fs-16" style="word-break: break-word">
          {{ $t("rewards.are_you_sure") }}
          <span class="fw-700">{{ confirmModalData.nameOfReward }}</span>
          {{ $t("rewards.redeemed_by") }}
          <span class="fw-700"
            >{{ confirmModalData.firsname }}
            {{ confirmModalData.lastname }}?</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusConfirmModal = false">{{
          $t("rewards.no")
        }}</el-button>
        <el-button @click="statusConfirmModal = false">{{
          $t("rewards.yes_and_refund")
        }}</el-button>
        <el-button @click="statusConfirmModal = false">{{
          $t("rewards.yes_and_do")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- Bulk Update Rates Modal -->
    <el-dialog
      :visible.sync="bulkUpdateModal"
      width="960px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeBulkUpdateModal"
      custom-class="bulk-update-dialog"
    >
      <template slot="title">
        <div class="fs-20 fw-700 fc-000000">{{ $t("rewards.bulk_update_coin_rates") }}</div>
      </template>

      <div class="bulk-update-content">
        <!-- Settings Row -->
        <div class="bulk-settings-row">
          <div class="bulk-setting-item">
            <label class="bulk-label">{{ $t("rewards.currency") }}</label>
            <el-select
              v-model="bulkUpdateCurrency"
              :placeholder="$t('rewards.select_currency')"
              size="medium"
              @change="onBulkCurrencyChange"
            >
              <el-option
                v-for="currency in availableCurrencies"
                :key="currency.code"
                :label="`${currency.code} (${currency.symbol})`"
                :value="currency.code"
              ></el-option>
            </el-select>
          </div>
          
          <div class="bulk-setting-item" v-if="bulkUpdateCurrency">
            <label class="bulk-label">{{ $t("rewards.current_rate") }}</label>
            <div class="bulk-rate-display">
              1 coin = {{ bulkCurrentRate.toFixed(2) }} {{ bulkUpdateCurrency }}
            </div>
          </div>

          <div class="bulk-setting-item" v-if="bulkUpdateCurrency">
            <label class="bulk-label">{{ $t("rewards.new_rate") }}</label>
            <div class="bulk-rate-input">
              <span>1 coin =</span>
              <el-input
                type="number"
                v-model.number="bulkNewRate"
                placeholder="0.00"
                size="medium"
                :min="0.01"
                step="0.01"
                @input="calculateBulkPreview"
              ></el-input>
              <span>{{ bulkUpdateCurrency }}</span>
            </div>
          </div>
        </div>

        <!-- Preview Table -->
        <div v-if="bulkUpdatePreview.length > 0" class="bulk-preview-section">
          <div class="bulk-preview-header">
            <div class="bulk-preview-title">
              <span class="fs-14 fw-600">{{ $t("rewards.preview_changes") }}</span>
              <span class="bulk-preview-count">{{ filteredBulkPreview.length }} {{ $t("rewards.of") }} {{ bulkUpdatePreview.length }} {{ $t("page.rewards").toLowerCase() }}</span>
            </div>
            <label class="bulk-filter-toggle">
              <span>{{ $t("rewards.show_only_changes") }}</span>
              <el-switch
                v-model="showOnlyChanges"
                active-color="#6c30cc"
              ></el-switch>
            </label>
          </div>
          
          <div class="bulk-preview-table thin-scrollbar">
            <table>
              <thead>
                <tr>
                  <th class="col-name">{{ $t("rewards.reward_name") }}</th>
                  <th class="col-value">{{ $t("rewards.value") }}</th>
                  <th class="col-current">{{ $t("rewards.current") }}</th>
                  <th class="col-new">{{ $t("rewards.new_coins") }}</th>
                  <th class="col-change">{{ $t("rewards.change") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(reward, index) in filteredBulkPreview" :key="reward.key">
                  <td class="col-name">
                    <span class="reward-name" :title="reward.reward_en">{{ reward.reward_en }}</span>
                  </td>
                  <td class="col-value">
                    {{ getCurrencySymbol(bulkUpdateCurrency) }}{{ Number(reward.price).toLocaleString() }}
                  </td>
                  <td class="col-current">
                    {{ Number(reward.coins).toLocaleString() }}
                  </td>
                  <td class="col-new">
                    <el-input
                      type="number"
                      v-model.number="reward.newCoins"
                      size="mini"
                      :min="0"
                      class="coin-input"
                    ></el-input>
                  </td>
                  <td class="col-change">
                    <span 
                      :class="{
                        'change-positive': reward.newCoins > reward.coins,
                        'change-negative': reward.newCoins < reward.coins,
                        'change-none': reward.newCoins === reward.coins
                      }"
                    >
                      {{ reward.newCoins - reward.coins > 0 ? '+' : '' }}{{ reward.newCoins - reward.coins }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else-if="bulkUpdateCurrency && bulkNewRate" class="bulk-empty-state">
          {{ $t("rewards.no_rewards_for_currency") }}
        </div>

        <div v-else-if="!bulkUpdateCurrency" class="bulk-empty-state">
          {{ $t("rewards.select_currency_hint") }}
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBulkUpdateModal" size="medium">{{ $t("global.CANCEL") }}</el-button>
        <el-button
          type="primary"
          size="medium"
          :disabled="!canApplyBulkUpdate"
          :loading="bulkUpdateLoading"
          @click="applyBulkUpdate"
        >
          {{ $t("rewards.apply") }} {{ changedRewardsCount }} {{ changedRewardsCount !== 1 ? $t("rewards.changes_suffix") : $t("rewards.change_singular") }}
        </el-button>
      </span>
    </el-dialog>
    <gem-exchange-editor
      :visible.sync="gemExchangeDrawerVisible"
      @saved="onGemExchangeSaved"
    />
    <linked-gem-variant-dialog
      :visible.sync="linkedGemDialogVisible"
      :source-reward="linkedGemSource"
      :master-reward="linkedGemMasterReward"
      :existing-variant="linkedGemExistingVariant"
      @saved="onLinkedGemVariantSaved"
    />
  </div>
</template>

<script>
//const moment = require('moment-timezone')
import Chart from "chart.js/auto";
import InfiniteLoading from "vue-infinite-loading";
import format from "date-fns/format";
import GemExchangeEditor from "./rewards/GemExchangeEditor.vue";
import LinkedGemVariantDialog from "./rewards/LinkedGemVariantDialog.vue";
import { findLinkedGemVariant, getMasterRewardId } from "@/utils/rewardVariants";
import {
  buildMemberRewardSpend,
  buildRewardCurrencyTotals,
  isDeliveredRewardActivity,
} from "@/utils/rewardActivity";

export default {
  name: "rewards",
  components: {
    InfiniteLoading,
    loadingEven: require("./even/loading").default,
    GemExchangeEditor,
    LinkedGemVariantDialog,
  },
  created() {
    this.$store.dispatch("reward/getTagMaster");
    this.$store.dispatch("reward/getRewardsMaster");
    this.$store.dispatch("reward/checkEngOnly");
    this.$store.dispatch("reward/getCountry");
    this.$store.dispatch("reward/getAllrewards_db", this.user);
    // this.$store.commit("reward/setTab", "0");
    this.$store.dispatch("reward/getRewards", this.user);
    this.$store.commit("authen/setActiveIndex", "5");
    this.$store.dispatch("reward/getList_month", this.user);
    this.$store.dispatch("reward/getAlluser", this.user);
    this.$store.dispatch("reward/getProcessingRedeemed", this.user);
    this.$store.dispatch("reward/loadGemExchangeConfig");
    // var moonLanding = new Date();
    // var cur_month = moonLanding.getMonth();
    // cur_month = cur_month + 1;
    // if (parseInt(cur_month) < 10) {
    //   cur_month = "0" + cur_month;
    // }
    // var cur_year = moonLanding.getFullYear();
    // var cur_start = cur_year + "-" + cur_month;
    // this.selectnum = cur_start;
    // this.$store.dispatch("reward/getRedeemed", [this.user, cur_start]);
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["reward/inputSearch"];
      },
      set(value) {
        this.$store.commit("reward/setinputSearch", { value });
      },
    },
    engonly() {
      return this.$store.getters["reward/engonly"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    rewards() {
      this.loadingRewardsTable = ++this.loadingRewardsTable;
      return this.$store.getters["reward/rewards"];
    },
    rewardsemptytext() {
      return this.$store.getters["reward/rewardsemptytext"];
    },
    showTextLoading() {
      return this.$store.getters["reward/showTextLoading"];
    },
    rewardActivityLoading() {
      return this.$store.getters["reward/rewardActivityLoading"];
    },
    rewardActivityRefreshing() {
      return this.$store.getters["reward/rewardActivityRefreshing"];
    },
    rewardActivityError() {
      return this.$store.getters["reward/rewardActivityError"];
    },
    redeemed() {
      return this.$store.getters["reward/redeemed"];
    },
    countrewards() {
      return this.$store.getters["reward/countrewards"];
    },
    list_month() {
      return this.$store.getters["reward/list_month"];
    },
    start_month() {
      return this.$store.getters["reward/start_month"];
    },
    loadmore_ck() {
      return this.$store.getters["reward/loadmore"];
    },
    badgeRedeemed() {
      return this.$store.getters["reward/processingRedeemed"];
    },
    optionsCountry() {
      return this.$store.getters["reward/country"];
    },
    memberCountries() {
      return this.$store.getters["reward/memberCountries"];
    },
    catalogCountries() {
      return this.$store.getters["reward/catalogCountries"];
    },
    selectedCountryFilter() {
      return this.$store.getters["reward/selectedCountryFilter"];
    },
    selectCountryFilterLabel() {
      if (this.selectedCountryFilter === 'all') {
        return this.$t('rewards.all_countries_label');
      } else if (this.selectedCountryFilter === 'members_only') {
        return this.$t('rewards.member_countries_only');
      } else {
        const country = this.catalogCountries.find(c => c.value === this.selectedCountryFilter);
        return country ? country.label : this.$t('rewards.all_countries_label');
      }
    },
    selectStatusLabel() {
      if (this.status === 'Y') return this.$t('rewards.enabled');
      if (this.status === 'N') return this.$t('rewards.disabled');
      return this.$t('rewards.show_all_status');
    },
    dataChart(){
      return this.$store.getters["reward/dataChart"];
    },
    companySymbol() {
      return this.$store.getters["reward/companySymbol"];
    },
    rewardActivityStats() {
      const rows = Array.isArray(this.redeemed) ? this.redeemed : [];
      const recipients = new Set();
      const members = new Set();
      let delivered = 0;
      let pending = 0;
      for (const r of rows) {
        if (!r) continue;
        if (isDeliveredRewardActivity(r)) {
          delivered += 1;
        } else if (r.status === 'P' || r.status === 'N') {
          pending += 1;
        }
        const key = r.send_to || r.user;
        if (key) recipients.add(key);
        const member = r.email || r.user;
        if (member) members.add(String(member).trim().toLowerCase());
      }
      return { total: rows.length, delivered, pending, recipients: recipients.size, members: members.size };
    },
    rewardActivityCurrencyTotals() {
      return buildRewardCurrencyTotals(this.redeemed);
    },
    memberRewardSpend() {
      return buildMemberRewardSpend(this.redeemed);
    },
    rewardActivityHeroValue() {
      const totals = this.rewardActivityCurrencyTotals;
      if (totals.length === 0) return `${this.companySymbol || ''}0`;
      if (totals.length === 1) return this.formatRewardActivityAmount(totals[0]);
      return this.fillI18nTemplate("rewards.currency_count", { count: totals.length });
    },
    rewardActivityHeroSub() {
      const period = this.selectMonth ? this.selectMonth : this.start_month;
      const totals = this.rewardActivityCurrencyTotals;
      if (totals.length > 1) {
        const breakdown = totals.map((item) => this.formatRewardActivityAmount(item)).join(" · ");
        return period ? `${breakdown} · ${period}` : breakdown;
      }
      return period
        ? this.fillI18nTemplate("rewards.delivered_reward_spend_period", { period })
        : this.$t("rewards.delivered_reward_spend");
    },
    rewardTableMaxHeight() {
      const h = Number(this.viewportHeight) || 900;
      const reservedHeight = this.rewardActivityView === "members" ? 446 : 396;
      return Math.max(300, h - reservedHeight);
    },
    tagMaster() {
      return this.$store.getters["reward/tagMaster"];
    },
    rewardsMasterData() {
      return this.$store.getters["reward/rewardsMasterData"];
    },
    rewardsCatalogRaw() {
      return this.$store.getters["reward/rewardsCatalogRaw"] || {};
    },
    linkedGemMasterRewardId() {
      return getMasterRewardId(this.linkedGemSource, this.linkedGemSource && this.linkedGemSource.key);
    },
    linkedGemMasterReward() {
      return this.rewardsMasterData[this.linkedGemMasterRewardId] || null;
    },
    linkedGemExistingVariant() {
      if (!this.linkedGemMasterRewardId) return null;
      return findLinkedGemVariant(this.rewardsCatalogRaw, this.linkedGemMasterRewardId);
    },
    language() {
      return this.$store.getters["reward/language"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    countNewReward(){
      return this.$store.getters["reward/countNewReward"];
    },
    canApplyBulkUpdate() {
      return this.bulkUpdateCurrency && 
             this.bulkUpdatePreview.length > 0 &&
             this.bulkUpdatePreview.some(r => r.newCoins !== r.coins);
    },
    changedRewardsCount() {
      return this.bulkUpdatePreview.filter(r => r.newCoins !== r.coins).length;
    },
    filteredBulkPreview() {
      if (this.showOnlyChanges) {
        return this.bulkUpdatePreview.filter(r => r.newCoins !== r.coins);
      }
      return this.bulkUpdatePreview;
    },
    allSymbol() {
      return this.$store.getters["reward/allSymbol"];
    },
    gemExchangeConfig() {
      return this.$store.getters["reward/gemExchangeConfig"];
    },
    gemExchangeEnabled() {
      return !!(this.gemExchangeConfig && this.gemExchangeConfig.enabled);
    },
    gemExchangeTierCount() {
      return (this.gemExchangeConfig && this.gemExchangeConfig.tiers)
        ? this.gemExchangeConfig.tiers.length
        : 0;
    },
    gemExchangeSummary() {
      const tiers = (this.gemExchangeConfig && this.gemExchangeConfig.tiers) || [];
      if (!tiers.length) return "";
      const gemsList = tiers.map(t => t.gems).sort((a, b) => a - b);
      const coinsList = tiers.map(t => t.coins_yield).sort((a, b) => a - b);
      const minG = gemsList[0], maxG = gemsList[gemsList.length - 1];
      const minC = coinsList[0], maxC = coinsList[coinsList.length - 1];
      const gemsStr = minG === maxG ? `${minG} gem${minG === 1 ? '' : 's'}` : `${minG}\u2013${maxG} gems`;
      const coinsStr = minC === maxC
        ? `${minC.toLocaleString()} coins`
        : `${minC.toLocaleString()}\u2013${maxC.toLocaleString()} coins`;
      return `${gemsStr} \u2192 ${coinsStr}`;
    },
    limitValueUnit() {
      if (this.ruleFormReward.limitMode === "monthly") {
        return this.$t("rewards.limit_unit_per_month");
      }
      if (this.ruleFormReward.limitMode === "total") {
        return this.$t("rewards.limit_unit_total");
      }
      return "";
    },
    limitHelperText() {
      const limit = Number(this.ruleFormReward.limitValue) || 0;
      if (this.ruleFormReward.limitMode === "monthly") {
        // Stale `monthly_period` will be reset by the Cloud Function on the
        // next redemption, so treat it as 0 used for display.
        const period = this.ruleFormReward.monthlyPeriod || "";
        const currentMonth = format(new Date(), "YYYY-MM");
        const rawUsed = Number(this.ruleFormReward.usedCount) || 0;
        const used = period === currentMonth ? rawUsed : 0;
        const available = Math.max(limit - used, 0);
        return this.fillI18nTemplate("rewards.limit_monthly_helper", { available, limit, used });
      }
      if (this.ruleFormReward.limitMode === "total") {
        const used = Number(this.ruleFormReward.usedCount) || 0;
        return this.fillI18nTemplate("rewards.limit_total_helper", { limit, used });
      }
      return "";
    }
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("reward/searchRewards", this.inputSearch);
    },
    dataChart(){
      if (!this.dialogFormRedeemed) {
        return;
      }

      this.$nextTick(() => {
        this.randerBarChartRewardActivity();
      });
    },
    rewardActivityLoading(value) {
      if (!value && this.dialogFormRedeemed && !this.rewardActivityError) {
        this.$nextTick(() => {
          this.randerBarChartRewardActivity();
        });
      }
    },
    dialogFormRedeemed(value) {
      if (this.reward_activity_bar_chart) {
        this.reward_activity_bar_chart.destroy();
        this.reward_activity_bar_chart = null;
      }

      if (value && this.dataChart && Array.isArray(this.dataChart.data) && this.dataChart.data.length > 0) {
        this.$nextTick(() => {
          this.randerBarChartRewardActivity();
        });
      }
    },
    language(){
      for(const i in this.language){
        if(!this.rules[`names.${this.language[i].code}`]){
          this.rules[`names.${this.language[i].code}`] = [
            { required: true, message: `Please input the ${this.language[i].text} name`, trigger: 'blur' }
          ]
        }
        
      }
    },

  },
  data() {
    return {
      viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 900,
      activeIndex:'en',
      id: "",
      company: "",
      mode: "",
      selectMonth: "",
      selectnum: format(new Date(),"YYYY-MM"),
      customDateRange: null,
      showCustomDateDialog: false,
      isCustomDateRange: false,
      tab: "0",
      anchor: {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
      },
      gemExchangeDrawerVisible: false,
      linkedGemDialogVisible: false,
      linkedGemSource: null,
      width: "",
      title_dialog: "",
      dialogFormVisible: false,
      dialogFormEdit: false,
      dialogFormRedeemed: false,
      formLabelWidth: "120px",
      imageUrl: "",
      value4: "",
      status: "all",
      loadmord: 1,
      ruleForm: {
        names:{},
        name: "",
        name_en: "",
        descriptions:{},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "3",
        qty: "",
        filename: "",
        file: [],
        master: false,
      },
      dialogFormReward: false,
      intervalHolding: false,
      limitIntervalHolding: false,
      dialogFormRewardRule: "add",
      ruleFormReward: {
        name: "",
        name_en: "",
        names:{},
        descriptions:{},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "0",
        qty: "",
        filename: "",
        file: [],
        master: false,
        linkedVariant: false,
        country: "All Countries",
        quantity: false,
        quantityLimits: 0,
        quantityLimitsMaster: 0,
        monthlyPeriod: "",
        limitMode: "unlimited",
        limitValue: 0,
        usedCount: 0,
        isMonthly: false,
      },
      rules: {
        'names.en': [
          { required: true, message: 'Please input the English name', trigger: 'blur' },
        ],
        name: [
          {
            required: true,
            message: "Please input name of reward in all active languages",
            trigger: "blur",
          },
        ],
        duration: [
          {
            type: "array",
            required: true,
            message: "Please pick a date",
            trigger: "change",
          },
        ],
        cost: [
          {
            required: true,
            message: "Please input cost of reward",
            trigger: "blur",
          },
        ],
        coins: [
          {
            required: true,
            message: "Please input amount of coins",
            trigger: "blur",
          },
        ],
        gems: [
          {
            required: true,
            message: "Please input amount of gems",
            trigger: "blur",
          },
        ],
      },
      btnSave: "",
      btnDelete: "",
      enabled_instant: true,
      loadingRewardsTable: -1,
      statusConfirmModal: false,
      confirmModalData: {
        nameOfReward: "Name of Reward",
        firsname: "Firstname",
        lastname: "Lastname",
      },
      oldtab:0,
      // Bulk Update Modal Data
      bulkUpdateModal: false,
      bulkUpdateCurrency: '',
      bulkCurrentRate: 0,
      bulkNewRate: null,
      bulkUpdatePreview: [],
      bulkUpdateLoading: false,
      availableCurrencies: [],
      showOnlyChanges: false,
      rewardActivityWarmupTimer: null,
      reward_activity_bar_chart: null,
      rewardActivityView: "transactions"
    };
  },
  mounted() {
        
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.tab = params;
      this.$store.commit("reward/setTab", this.tab);
      this.$store.commit("reward/setinputSearch", "");
      this.$store.dispatch("reward/applyRewardFilters");
    } else {
      if (this.$route.query.welcome == "true") {
        this.$router.push({
          name: "rewards",
          params: { tab: "0" },
          query: { welcome: "false" },
        });
      } else {
        this.$router.push({ name: "rewards", params: { tab: "0" } });
      }
    }
    this.rootChangeTabHandler = (item) => {
      if (item.path == "rewards") {
        item.name = item.tab;
        this.handleClick(item);
      }
    };
    this.$root.$on('changeTab', this.rootChangeTabHandler);
    this.queueRewardActivityWarmup();
    // rAF-coalesced so a 60fps resize drag schedules one viewportHeight
    // update per frame (not per event) — prevents el-table from relayouting
    // dozens of times per second on drag.
    this.onViewportResize = () => {
      if (this.viewportResizeRaf) return;
      this.viewportResizeRaf = window.requestAnimationFrame(() => {
        this.viewportResizeRaf = null;
        this.viewportHeight = window.innerHeight;
      });
    };
    window.addEventListener('resize', this.onViewportResize);
  },
  beforeDestroy(){
    // console.log('beforeDestroy')
    if (this.onViewportResize) {
      window.removeEventListener('resize', this.onViewportResize);
      this.onViewportResize = null;
    }
    if (this.viewportResizeRaf) {
      window.cancelAnimationFrame(this.viewportResizeRaf);
      this.viewportResizeRaf = null;
    }
    if (this.rootChangeTabHandler) {
      this.$root.$off('changeTab', this.rootChangeTabHandler);
    }
    if (this.rewardActivityWarmupTimer) {
      clearTimeout(this.rewardActivityWarmupTimer);
      this.rewardActivityWarmupTimer = null;
    }
    if (this.reward_activity_bar_chart) {
      this.reward_activity_bar_chart.destroy();
      this.reward_activity_bar_chart = null;
    }
    this.$store.dispatch("reward/setOldReward",0);
  },
  methods: {
    queueRewardActivityWarmup() {
      if (this.rewardActivityWarmupTimer) {
        return;
      }

      this.rewardActivityWarmupTimer = setTimeout(() => {
        this.rewardActivityWarmupTimer = null;
        this.$store.dispatch("reward/getRedeemedChart", { user: this.user });
      }, 1200);
    },
    parseRewardDateTime(value) {
      if (!value) {
        return null;
      }

      if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
      }

      if (typeof value !== "string") {
        return null;
      }

      const normalizedValue = value.trim();
      if (!normalizedValue) {
        return null;
      }

      const slashDateMatch = normalizedValue.match(
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/
      );
      if (slashDateMatch) {
        const [, day, month, year, hour = "0", minute = "0"] = slashDateMatch;
        const parsedDate = new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hour),
          Number(minute)
        );

        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      const dashDateMatch = normalizedValue.match(
        /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
      );
      if (dashDateMatch) {
        const [, year, month, day, hour = "0", minute = "0", second = "0"] =
          dashDateMatch;
        const parsedDate = new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hour),
          Number(minute),
          Number(second)
        );

        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      const fallbackDate = new Date(normalizedValue);
      return isNaN(fallbackDate.getTime()) ? null : fallbackDate;
    },
    getRewardDuration(item) {
      const startDate = this.parseRewardDateTime(item && item.starton);
      const endDate = this.parseRewardDateTime(item && item.endon);

      if (!startDate || !endDate) {
        return [];
      }

      return [startDate, endDate];
    },
    onInputNameEn(text) {

      if (this.engonly) {
        this.ruleFormReward.names[this.activeIndex] = text;
      }
    },
    onInputDescEn(text) {
      if (this.engonly) {

        this.ruleFormReward.descriptions[this.activeIndex] = text;
      }
    },
    handleBlock(item) {
      if (item && item.managed_by === "gem_exchange") {
        // Tier rewards are managed by Gem Exchange; revert the switch and route admin to the editor.
        item.block_status = !item.block_status;
        this.$message.info(this.$t("rewards.toast_managed_by_gem_exchange"));
        this.openGemExchangeEditor();
        return;
      }
      this.$store.dispatch("reward/blockReward", item);
    },
    loadmore($state) {
      if (this.loadmore_ck == true) {
        var moonLanding = new Date();
        var cur_month = moonLanding.getMonth();
        this.$store.dispatch("reward/getRedeemed_loadmore", [
          this.user,
          cur_month + 1,
        ]);
        setTimeout(() => {
          $state.loaded();
        }, 2000);
      } else {
        $state.complete();
      }
    },
    handleClick(tab, event) {
      const tabName = tab.name || "";
      this.tab = tabName;
      this.loadingRewardsTable = -1;
      const paramsTab = this.$router.currentRoute.params.tab;
      if (paramsTab != tabName) {
        this.$router.push({ name: "rewards", params: { tab: tabName } });
      }
      this.$store.commit("reward/setTab", this.tab); 
      this.$store.commit("reward/setinputSearch", "");
      this.$store.dispatch("reward/setOldReward",this.oldtab);
      this.$store.dispatch("reward/applyRewardFilters");
      this.oldtab = this.tab;
    },
    handleActivate(index, item) {
      this.$confirm(
        this.$t("rewards.toast_confirm_activate"),
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("reward/activateReward", item);
          this.$message({
            type: "success",
            message: this.$t("rewards.toast_reward_activated"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("rewards.toast_canceled"),
          });
        });
    },
    handleDisable(index, item) {
      this.$confirm(
        this.$t("rewards.toast_confirm_disable"),
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("reward/disableReward", item);
          this.$message({
            type: "success",
            message: this.$t("rewards.toast_reward_disabled"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("rewards.toast_canceled"),
          });
        });
    },
    countryFilterClick(filterValue) {
      this.$store.commit("reward/setSelectedCountryFilter", filterValue);
      this.$store.dispatch("reward/applyRewardFilters");
    },
    statusClick(type) {
      const opt = [];
      opt["Active"] = "Y";
      opt["Inactive"] = "N";
      opt["Show All"] = "all";
      this.status = opt[type];
      this.$store.commit("reward/setselectShow", { type: opt[type] });
      this.$store.dispatch("reward/selectStatus", this.status);
    },
    monthClick(num, label) {
      if (num === 'custom') {
        this.showCustomDateDialog = true;
        return;
      }

      this.$store.commit("reward/setLoadmore", false);
      this.selectMonth = label;
      this.isCustomDateRange = false;
      this.customDateRange = null;

      if (num != "-6" && num != "all" && num != "-3") {
        if (parseInt(num) < 10) {
          num = "0" + num;
        }
        var label = label.split(" ");
        num = label[1] + "-" + num;
      }

      this.selectnum = num;
      this.$store.dispatch("reward/getRedeemedSelectMonth", [this.user, num]);
    },
    closeCustomDateDialog() {
      this.showCustomDateDialog = false;
      this.customDateRange = null;
    },
    handleCustomDateConfirm() {
      if (!this.customDateRange || this.customDateRange.length !== 2) {
        this.$message({
          type: "warning",
          message: this.$t("rewards.toast_select_valid_date_range"),
        });
        return;
      }

      this.$store.commit("reward/setLoadmore", false);
      this.isCustomDateRange = true;
      const startDate = this.customDateRange[0];
      const endDate = this.customDateRange[1];
      const dateRangeStr = `custom:${startDate}:${endDate}`;
      this.selectnum = dateRangeStr;
      
      // Format display label
      const startFormatted = format(new Date(startDate), 'MMM D');
      const endFormatted = format(new Date(endDate), 'MMM D');
      this.selectMonth = `${startFormatted} To ${endFormatted}`;
      
      this.showCustomDateDialog = false;
      this.$store.dispatch("reward/getRedeemedSelectMonth", [this.user, dateRangeStr]);
    },
    redeemedClick(row, status) {
      let id = row.id
      var _this = this;
      let txt = ''
      let txt_complete = ''
      if(status == 'X'){
        txt = this.$t("rewards.toast_confirm_cancel_transaction")
        txt_complete = this.$t("rewards.toast_transaction_canceled")
      }else if(status == 'C'){
        txt = `${this.$t("rewards.toast_confirm_cancel_transaction")} ${this.$t("rewards.toast_coins_gems_refunded_prefix")} ${row.user}.`
        txt_complete = this.$t("rewards.toast_transaction_canceled")
      }else{
        txt = this.$t("rewards.toast_confirm_status_change")
        txt_complete = this.$t("rewards.toast_status_updated")
      }
      this.$confirm(
        `${txt}`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("reward/redeemed_change", [
            id,
            status,
            this.user,
            this.selectnum,
          ]);
          this.$store.dispatch("reward/getProcessingRedeemed", this.user);
          this.$message({
            type: "success",
            message: `${txt_complete}`,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("rewards.toast_canceled"),
          });
        });
    },
    addReward() {
      this.title_dialog = this.$t("rewards.add_a_reward");
      this.mode = "";
      this.dialogFormVisible = true;
      this.imageUrl = "";
      this.btnSave = "ADD";
      this.ruleForm = {
        names: {},
        name: "",
        name_en: "",
        descriptions: {},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "3",
        qty: "",
        filename: "",
        file: [],
        master: false,
      };
      this.ruleFormReward= {
        name: "",
        name_en: "",
        names:{},
        descriptions:{},
        description: "",
        description_en: "",
        costSelected: "coins",
        cost: null,
        coins: "",
        gems: "",
        duration: [],
        type: "0",
        qty: "",
        filename: "",
        file: [],
        master: false,
        linkedVariant: false,
        country: "All Countries",
        quantity: false,
        quantityLimits: 0,
        quantityLimitsMaster: 0,
        monthlyPeriod: "",
        limitMode: "unlimited",
        limitValue: 0,
        usedCount: 0,
        isMonthly: false,
      }
    },
    editReward(index, item) {
      this.title_dialog = "Edit a Reward";
      this.dialogFormEdit = true;
      if (item.img) {
        this.imageUrl = item.img;
      }
      this.id = item.key;
      this.company = item.company;
      this.btnSave = this.$t("global.SAVE");
      this.btnDelete = "DELETE";
      this.mode = "edit";
      this.ruleForm = {
        name: item.reward,
        name_en: item.reward_en,
        description: item.description,
        description_en: item.description_en,
        costSelected: item.gems > 0 ? "gems" : "coins",
        cost: item.gems > 0 ? item.gems : item.coins,
        duration: this.getRewardDuration(item),
        type: item.type,
        qty: item.qty === 0 ? "" : item.qty,
        filename: item.filename,
        file: [],
        master: item.edit === "N" ? true : false,
        quantityLimits: item.limit ? item.limit : 0,
        quantity: item.limit ? true : false,
      };
    },
    handleSelect(key, keyPath) {
      
      this.activeIndex = key;
    },
    openRedeemed() {
      if (this.rewardActivityWarmupTimer) {
        clearTimeout(this.rewardActivityWarmupTimer);
        this.rewardActivityWarmupTimer = null;
      }

      this.dialogFormRedeemed = true;
      this.title_dialog = "Redeemed Rewards";
      this.mode = "";
      this.imageUrl = "";
      this.btnSave = "Add";
      this.ruleForm = {};

      this.loadRewardActivity(false);
    },
    retryRewardActivity() {
      this.loadRewardActivity(true);
    },
    loadRewardActivity(force) {
      const selectedMonth = this.selectnum || format(new Date(), "YYYY-MM");
      const currentMonth = format(new Date(), "YYYY-MM");

      return this.$store.dispatch("reward/getRedeemedChart", {
        user: this.user,
        force: !!force,
      }).then(() => {
        if (this.dialogFormRedeemed && selectedMonth !== currentMonth) {
          return this.$store.dispatch("reward/getRedeemedSelectMonth", [this.user, selectedMonth]);
        }
        return null;
      }).catch((error) => {
        console.error("Failed to load reward activity", error);
        return null;
      });
    },
    async submitReward(mode) {
      this.$refs["ruleForm"].validate((valid) => {
        if (mode != "edit") {
          if (this.ruleFormReward.file.length == 0) {
            this.$message({
              type: "error",
              message: this.$t("rewards.toast_select_image"),
            });
            valid = false;
          }
        }
        if (valid) {
          this.applyLimitMode();
          if (mode == "edit") {
            const data = this.ruleFormReward;
            data["key"] = this.id;
            this.$store.dispatch("reward/updateReward", data).then(() => {
              this.dialogFormReward = false;
              this.update_success();
            });
          } else {
            this.$store
              .dispatch("reward/createReward", this.ruleFormReward)
              .then(() => {
                this.dialogFormReward = false;
                this.update_success();
              });
          }
        } else {
          return false;
        }
      });
    },
    applyLimitMode() {
      // monthly_period (written via isMonthly) is the only field that distinguishes
      // a monthly cap from a lifetime cap on disk; the Cloud Function uses it to
      // roll `used` over each calendar month.
      const value = Number(this.ruleFormReward.limitValue) || 0;
      const mode = this.ruleFormReward.limitMode;
      if (mode === "total" || mode === "monthly") {
        this.ruleFormReward.quantity = true;
        this.ruleFormReward.quantityLimits = value;
        this.ruleFormReward.isMonthly = mode === "monthly";
      } else {
        this.ruleFormReward.quantity = false;
        this.ruleFormReward.quantityLimits = 0;
        this.ruleFormReward.isMonthly = false;
      }
    },
    openGemExchangeEditor() {
      this.gemExchangeDrawerVisible = true;
    },
    onGemExchangeSaved() {
      this.$store.dispatch("reward/getRewards", this.user);
    },
    openLinkedGemVariant() {
      const source = this.rewardsCatalogRaw[this.id];
      if (!source) {
        this.$message.error(this.$t("rewards.linked_gem_variant.errors.missing_source_reward"));
        return;
      }
      this.linkedGemSource = { key: this.id, ...source, img: this.imageUrl || source.img };
      this.linkedGemDialogVisible = true;
    },
    onLinkedGemVariantSaved() {
      this.$store.dispatch("reward/reprocessRewardsFromCache");
    },
    editRewardNew(index, item) {
      if (item && item.managed_by === "gem_exchange") {
        this.openGemExchangeEditor();
        return;
      }
      this.dialogFormRewardRule = "edit";
      this.imageUrl = item.img || null;
      this.id = item.key;
      this.company = item.company;
      //if(item.country)
      this.ruleFormReward = {
        names:item.names,
        name: item.reward,
        name_en: item.reward_en,
        descriptions:item.descriptions,
        description: item.description,
        description_en: item.description_en,
        costSelected: item.gems > 0 ? "gems" : "coins",
        cost: item.gems > 0 ? item.gems : item.coins,
        duration: this.getRewardDuration(item),
        // type: item.type,
        type: item.tag_value,
        qty: "", // space for set default
        filename: item.filename,
        file: [],
        master: item.edit === "N" ? true : false,
        linkedVariant: !!item.master_reward_id,
        country: item.country ? item.country : "All Countries",
        quantityLimits: 0, // 0 for set default
        quantityLimitsMaster: (this.rewardsMasterData[getMasterRewardId(item, item.key)] && this.rewardsMasterData[getMasterRewardId(item, item.key)].qty > 0)  ? this.rewardsMasterData[getMasterRewardId(item, item.key)].qty : 0,
        quantity: item.promotion == "Y" ? true : false,
        approval: item.approval_reward == "Y" ? true : false,
        monthlyPeriod: item.monthly_period ? item.monthly_period : "",
        limitMode: "unlimited",
        limitValue: 0,
        usedCount: Number(item.used) || 0,
        isMonthly: false,
      };
      if (item.promotion === "Y" && Number(item.qty) > 0) {
        this.ruleFormReward.limitMode = item.monthly_period ? "monthly" : "total";
        this.ruleFormReward.limitValue = Number(item.qty);
        this.ruleFormReward.isMonthly = !!item.monthly_period;
      }
      if(item.qty && item.qty > 0){
        if(item.used && item.used > 0){
          this.ruleFormReward.qty = item.qty - item.used
        }else{
          this.ruleFormReward.qty = item.qty
        }
      }else{
        this.ruleFormReward.qty = ""
      }
      if(this.ruleFormReward.quantityLimitsMaster > 0){
        if(this.ruleFormReward.qty && this.ruleFormReward.qty > 0){
          if(this.ruleFormReward.qty > this.ruleFormReward.quantityLimitsMaster){
            this.ruleFormReward.quantityLimits = this.ruleFormReward.quantityLimitsMaster
          }else{
            this.ruleFormReward.quantityLimits = this.ruleFormReward.qty
          }
        }else{
          this.ruleFormReward.quantityLimits = this.ruleFormReward.quantityLimitsMaster
        }
      }else{
        this.ruleFormReward.quantityLimits = this.ruleFormReward.qty ? this.ruleFormReward.qty : 0
      }
      this.dialogFormReward = true;
    },
    clearRewardFrom() {
      this.ruleFormReward.names = {};
      this.ruleFormReward.name = "";
      this.ruleFormReward.name_en = "";
      this.ruleFormReward.descriptions = {};
      this.ruleFormReward.description = "";
      this.ruleFormReward.description_en = "";
      this.ruleFormReward.costSelected = "coins";
      this.ruleFormReward.cost = "";
      this.ruleFormReward.coins = "";
      this.ruleFormReward.gems = "";
      this.ruleFormReward.duration = [];
      this.ruleFormReward.type = "0";
      this.ruleFormReward.qty = "";
      this.ruleFormReward.filename = "";
      this.ruleFormReward.file = "";
      this.ruleFormReward.master = false;
      this.ruleFormReward.linkedVariant = false;
      this.ruleFormReward.country = "All Countries";
      this.dialogFormReward = false;
      this.imageUrl = null;
      this.dialogFormRewardRule = "add";
      this.ruleFormReward.quantityLimitsMaster = 0;
      (this.ruleFormReward.quantityLimits = 0),
        (this.ruleFormReward.quantity = false);
      this.ruleFormReward.approval = false;
      this.ruleFormReward.monthlyPeriod = "";
      this.ruleFormReward.limitMode = "unlimited";
      this.ruleFormReward.limitValue = 0;
      this.ruleFormReward.usedCount = 0;
      this.ruleFormReward.isMonthly = false;
    },
    addImage(file, fileList) {
      this.ruleFormReward.file = [];
      this.ruleFormReward.file.push(file.file);
      this.imageUrl = URL.createObjectURL(file.file);
    },
    saveReward() {
      this.$refs["ruleForm"].validate((valid) => {
        if (this.mode != "edit") {
          if (this.ruleForm.file.length == 0) {
            valid = false;
          }
        }

        if (valid) {
          if (this.mode == "edit") {
            const data = this.ruleForm;
            data["key"] = this.id;
            this.$store.dispatch("reward/updateReward", data);
          } else {
            this.$store.dispatch("reward/createReward", this.ruleForm);
          }
          this.update_success();
          this.dialogFormEdit = false;
        } else {
          return false;
        }
      });
    },
    deleteReward() {
      const data = this.ruleFormReward;
      data["key"] = this.id;

      this.$confirm(this.$t("rewards.toast_confirm_delete"), "Warning", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("reward/deleteReward", data);
          this.$message({
            type: "success",
            message: this.$t("rewards.toast_reward_deleted"),
          });
          this.clearRewardFrom();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("rewards.toast_canceled"),
          });
        });
    },
    cancelEditReward() {
      this.dialogFormEdit = false;
      this.clearRewardFrom();
      this.$refs["ruleForm"].clearValidate();
    },
    cancelReward() {
      this.dialogFormVisible = false;
      this.clearRewardFrom();
      this.$refs["ruleForm"].clearValidate();
    },

    update_success() {
      let message = this.$t("rewards.toast_reward_added");
      if (this.mode == "edit") {
        message = this.$t("rewards.toast_reward_updated");
      }

      //this.cancelReward();
      this.$message({
        type: "success",
        message,
      });
    },
    addAttachment(file, fileList) {
      this.ruleForm.file = [];
      this.ruleForm.file.push(file.file);
      this.imageUrl = URL.createObjectURL(file.file);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error(this.$t("rewards.toast_avatar_format_error"));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("rewards.toast_avatar_size_error"));
      }
      return isJPG && isLt2M;
    },
    checkCost() {
      this.$refs["ruleForm"].clearValidate();
    },
    startHold(value) {
      if (!this.intervalHolding) {
        this.intervalHolding = setInterval(
          () => this.quantityLimits(value),
          60
        );
      }
    },
    stopHold() {
      clearInterval(this.intervalHolding);
      this.intervalHolding = false;
    },
    setLimitMode(mode) {
      this.ruleFormReward.limitMode = mode;
      if (mode === "unlimited") {
        this.ruleFormReward.limitValue = 0;
      } else if (!this.ruleFormReward.limitValue || this.ruleFormReward.limitValue < 1) {
        this.ruleFormReward.limitValue = 1;
      }
    },
    fillI18nTemplate(key, vars) {
      const tpl = this.$t(key);
      if (typeof tpl !== "string") return "";
      return Object.keys(vars).reduce(
        (acc, k) => acc.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]),
        tpl
      );
    },
    formatRewardActivityAmount(item) {
      if (!item) return "";
      const amount = Number(item.amount !== undefined ? item.amount : item.value) || 0;
      const formatted = this.$utils("addCommasInNumber", amount);
      if (item.symbol) return `${item.symbol}${formatted}`;
      if (item.currency && item.currency !== "Unknown") return `${item.currency} ${formatted}`;
      return formatted;
    },
    formatRewardActivityShare(value) {
      const share = Number(value) || 0;
      if (share > 0 && share < 1) return "<1%";
      return `${Math.round(share)}%`;
    },
    startHoldLimit(delta) {
      this.adjustLimit(delta);
      if (!this.limitIntervalHolding) {
        this.limitIntervalHolding = setInterval(
          () => this.adjustLimit(delta),
          60
        );
      }
    },
    stopHoldLimit() {
      clearInterval(this.limitIntervalHolding);
      this.limitIntervalHolding = false;
    },
    adjustLimit(delta) {
      const next = (Number(this.ruleFormReward.limitValue) || 0) + delta;
      const ceiling = Number(this.ruleFormReward.quantityLimitsMaster) || 0;
      let bounded = next;
      if (next < 0) bounded = 0;
      if (this.ruleFormReward.limitMode === "total" && ceiling > 0 && bounded > ceiling) {
        bounded = ceiling;
      }
      this.ruleFormReward.limitValue = bounded;
    },
    quantityLimits(value) {
      let limit = this.ruleFormReward.quantityLimits + value;
      if(this.ruleFormReward.quantityLimitsMaster > 0){
        if(limit > 0){
          if(limit <= this.ruleFormReward.quantityLimitsMaster) {
            this.ruleFormReward.quantityLimits = limit;
          }
        }else{
          this.ruleFormReward.quantityLimits = 0;
        }
      }else{
        if(limit > 0) {
          this.ruleFormReward.quantityLimits = limit;
        } else {
          this.ruleFormReward.quantityLimits = 0;
        }
      }
    },
    exportTable() {
      if (this.rewardActivityView === "members") {
        return this.$store.dispatch("reward/exportMemberSpend", {
          period: this.selectMonth || this.start_month,
          rows: this.memberRewardSpend,
        });
      }
      return this.$store.dispatch("reward/exportTable",this.selectnum);
    },
    randerBarChartRewardActivity() {
      var rewardActivityBarchart = this.$refs.rewardActivityBarchart;
      if (this.reward_activity_bar_chart) {
        this.reward_activity_bar_chart.destroy();
        this.reward_activity_bar_chart = null;
      }

      if (
        !rewardActivityBarchart ||
        !this.dataChart ||
        !Array.isArray(this.dataChart.label_month) ||
        !Array.isArray(this.dataChart.data) ||
        this.dataChart.label_month.length === 0
      ) {
        return;
      }

      // [
      //   "SEP",
      //   "OCT",
      //   "NOV",
      //   "DEC",
      //   "JAN",
      //   "FEB",
      //   "MAR",
      //   "APR",
      //   "MAY",
      //   "JUN",
      //   "JUL",
      //   "AUG",
      //   "SEP",
      // ];
      const month_years =this.dataChart.label_month_year
      //  [
      //   "SEP 2021",
      //   "OCT 2021",
      //   "NOV 2021",
      //   "DEC 2021",
      //   "JAN 2022",
      //   "FEB 2022",
      //   "MAR 2022",
      //   "APR 2022",
      //   "MAY 2022",
      //   "JUN 2022",
      //   "JUL 2022",
      //   "AUG 2022",
      //   "SEP 2022",
      // ];
      const disable_tooltip = [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
      ];
      // 242 => 1% of max value in this array!
      const value =this.dataChart.data 
      // [
      //   242, 242, 242, 242, 242, 242, 242, 242, 242, 23000.0, 19700.08, 26050.2,
      //   24200.00,
      // ];
      // this.loadingChartStatus = false;
      const ctx = rewardActivityBarchart.getContext("2d");
      const numericValues = Array.isArray(value) ? value.map(v => Number(v) || 0) : [];
      const peakIndex = numericValues.length ? numericValues.indexOf(Math.max(...numericValues)) : -1;
      // Chart.js calls scriptable color resolvers per bar per frame — build
      // each gradient once per render, cached on the chart instance by area
      // height so a resize invalidates them cleanly.
      const makeGradient = (top, bottom, area) => {
        const g = ctx.createLinearGradient(0, area.top, 0, area.bottom);
        g.addColorStop(0, top);
        g.addColorStop(1, bottom);
        return g;
      };
      const resolveBarColor = (barCtx) => {
        const area = barCtx.chart.chartArea;
        if (!area) return "#6C30CC";
        const cache = barCtx.chart.$raBarGradients;
        const signature = `${area.top}:${area.bottom}`;
        if (!cache || cache.signature !== signature) {
          barCtx.chart.$raBarGradients = {
            signature,
            base: makeGradient("#7B3FD9", "#5822A8", area),
            peak: makeGradient("#9A5CF2", "#6C30CC", area),
          };
        }
        return barCtx.dataIndex === peakIndex
          ? barCtx.chart.$raBarGradients.peak
          : barCtx.chart.$raBarGradients.base;
      };
      const rewardActivityBarChartData = {
        labels:  this.dataChart.label_month,
        datasets: [
          {
            label: this.companySymbol,
            data: value,
            months_years: month_years,
            disable_tooltip: disable_tooltip,
            backgroundColor: resolveBarColor,
            hoverBackgroundColor: "#5A25B0",
            borderColor: "transparent",
            borderWidth: 0,
            borderSkipped: false,
            datalabels: {
              color: "#000",
            },
          },
        ],
      };
      const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
      options.datasets.bar = {
        categoryPercentage: 0.62,
        barPercentage: 0.72,
        borderRadius: 6,
      };
      options.scales.x = {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          textStrokeWidth: 0,
          color: "#9aa0ac",
          font: {
            size: 11,
            weight: "600",
            family: "Lato, Arial, sans-serif",
          },
        },
      };
      if (options.scales.y) {
        options.scales.y.grid = {
          display: false,
          drawBorder: false,
        };
      }
      options.layout = {
        padding: {
          top: 18,
          right: 4,
          left: 4,
        },
      };
      options.plugins.tooltip = {
        mode: "index",
        position: "nearest",
        filter: function (tooltipItems) {
          const value = tooltipItems.dataset.disable_tooltip[
            tooltipItems.dataIndex
            ] || false
          return value;
        },
        callbacks: {
          title: (tooltipItems) => {
            if (tooltipItems.length != 0) {
              return (
                tooltipItems[0].dataset.months_years[
                  tooltipItems[0].dataIndex
                ] || ""
              );
            }
            return ""
          },
          label: function (tooltipItems) {
            const label = tooltipItems.dataset.label;
            const value = tooltipItems.formattedValue;
            let str = value.toString().split(".");
            if (str[0].length >= 4) {
              str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
            }
            if (str[1]) {
              if (str[1] === "0") {
                str = str[0] + ".00";
              } else if (str[1].length < 2) {
                str = str.join(".");
                str = str + "0";
              } else {
                str = str.join(".");
              }
            } else {
              str = str[0] + ".00";
            }
            return `${label} ${str}`;
          },
        },
      };
      this.reward_activity_bar_chart = new Chart(
        rewardActivityBarchart.getContext("2d"),
        {
          type: "bar",
          data: rewardActivityBarChartData,
          options: options,
        }
      );
    },
    // Bulk Update Methods
    async openBulkUpdateModal() {
      this.bulkUpdateModal = true;
      this.bulkUpdateCurrency = '';
      this.bulkCurrentRate = 0;
      this.bulkNewRate = null;
      this.bulkUpdatePreview = [];
      
      // Load available currencies from gift card rewards
      await this.loadAvailableCurrencies();
    },
    closeBulkUpdateModal() {
      this.bulkUpdateModal = false;
      this.bulkUpdateCurrency = '';
      this.bulkCurrentRate = 0;
      this.bulkNewRate = null;
      this.bulkUpdatePreview = [];
      this.showOnlyChanges = false;
    },
    async loadAvailableCurrencies() {
      // Get all gift card rewards (tab 0) and extract unique currencies
      const currencyMap = {};
      const rewards = await this.$store.dispatch("reward/getGiftCardRewardsForBulkUpdate");
      
      if (rewards && rewards.length > 0) {
        rewards.forEach(reward => {
          const currency = reward.reward_currency || this.getCurrencyFromCountry(reward.country);
          if (currency && reward.price && Number(reward.price) > 0) {
            if (!currencyMap[currency]) {
              currencyMap[currency] = {
                code: currency,
                symbol: this.getCurrencySymbol(currency),
                count: 0
              };
            }
            currencyMap[currency].count++;
          }
        });
      }
      
      this.availableCurrencies = Object.values(currencyMap).sort((a, b) => b.count - a.count);
    },
    getCurrencyFromCountry(countryCode) {
      // Map country codes to currency codes
      const countryToCurrency = {
        'TH': 'THB',
        'ID': 'IDR',
        'MY': 'MYR',
        'SG': 'SGD',
        'PH': 'PHP',
        'VN': 'VND',
        'US': 'USD',
        'GB': 'GBP',
        'EU': 'EUR',
        'JP': 'JPY',
        'KR': 'KRW',
        'CN': 'CNY',
        'HK': 'HKD',
        'TW': 'TWD',
        'AU': 'AUD',
        'IN': 'INR'
      };
      return countryToCurrency[countryCode] || 'THB';
    },
    getCurrencySymbol(currencyCode) {
      const symbols = {
        'THB': '฿',
        'IDR': 'Rp',
        'MYR': 'RM',
        'SGD': 'S$',
        'PHP': '₱',
        'VND': '₫',
        'USD': '$',
        'GBP': '£',
        'EUR': '€',
        'JPY': '¥',
        'KRW': '₩',
        'CNY': '¥',
        'HKD': 'HK$',
        'TWD': 'NT$',
        'AUD': 'A$',
        'INR': '₹'
      };
      return this.allSymbol[currencyCode] || symbols[currencyCode] || currencyCode;
    },
    async onBulkCurrencyChange() {
      // Reset preview when currency changes
      this.bulkNewRate = null;
      this.bulkUpdatePreview = [];
      
      if (!this.bulkUpdateCurrency) return;
      
      // Load rewards for the selected currency and calculate current rate
      const rewards = await this.$store.dispatch("reward/getGiftCardRewardsForBulkUpdate");
      const filteredRewards = rewards.filter(r => {
        const currency = r.reward_currency || this.getCurrencyFromCountry(r.country);
        return currency === this.bulkUpdateCurrency && r.price && Number(r.price) > 0 && r.coins > 0;
      });
      
      if (filteredRewards.length > 0) {
        // Calculate mode (most frequently used rate) - rounded to 2 decimals for grouping
        const rateCounts = {};
        filteredRewards.forEach(r => {
          const rate = (Number(r.price) / Number(r.coins)).toFixed(2);
          rateCounts[rate] = (rateCounts[rate] || 0) + 1;
        });
        
        // Find the rate with highest count (mode)
        let modeRate = 0;
        let maxCount = 0;
        for (const [rate, count] of Object.entries(rateCounts)) {
          if (count > maxCount) {
            maxCount = count;
            modeRate = parseFloat(rate);
          }
        }
        
        this.bulkCurrentRate = modeRate;
        
        // Pre-fill new rate with current rate
        this.bulkNewRate = parseFloat(this.bulkCurrentRate.toFixed(2));
        
        // Generate preview
        this.calculateBulkPreview();
      } else {
        this.bulkCurrentRate = 0;
      }
    },
    async calculateBulkPreview() {
      if (!this.bulkUpdateCurrency || !this.bulkNewRate || this.bulkNewRate <= 0) {
        this.bulkUpdatePreview = [];
        return;
      }
      
      const rewards = await this.$store.dispatch("reward/getGiftCardRewardsForBulkUpdate");
      const filteredRewards = rewards.filter(r => {
        const currency = r.reward_currency || this.getCurrencyFromCountry(r.country);
        return currency === this.bulkUpdateCurrency && r.price && Number(r.price) > 0;
      });
      
      this.bulkUpdatePreview = filteredRewards.map(r => ({
        ...r,
        newCoins: this.smartRoundCoins(Number(r.price) / this.bulkNewRate)
      }));
    },
    // Smart rounding to snap to nice round numbers
    smartRoundCoins(value) {
      const raw = Math.round(value);
      
      // Determine the rounding increment based on magnitude
      let increment;
      if (raw < 50) {
        increment = 5;      // Round to nearest 5 for small values
      } else if (raw < 200) {
        increment = 10;     // Round to nearest 10 for medium values
      } else if (raw < 500) {
        increment = 25;     // Round to nearest 25 for larger values
      } else {
        increment = 50;     // Round to nearest 50 for large values
      }
      
      // Calculate how close we are to the nearest round number
      const remainder = raw % increment;
      const threshold = increment * 0.3; // Snap if within 30% of the increment
      
      if (remainder <= threshold) {
        // Snap down to round number
        return raw - remainder;
      } else if (remainder >= increment - threshold) {
        // Snap up to round number
        return raw + (increment - remainder);
      }
      
      // Not close enough to snap, return the raw rounded value
      return raw;
    },
    async applyBulkUpdate() {
      if (!this.canApplyBulkUpdate) return;
      
      const changedRewards = this.bulkUpdatePreview.filter(r => r.newCoins !== r.coins);
      
      if (changedRewards.length === 0) {
        this.$message({
          type: "info",
          message: "No changes to apply"
        });
        return;
      }
      
      this.$confirm(
        `Are you sure you want to update ${changedRewards.length} reward(s)?`,
        "Confirm Bulk Update",
        {
          confirmButtonText: "Yes, Update All",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(async () => {
        this.bulkUpdateLoading = true;
        
        try {
          await this.$store.dispatch("reward/bulkUpdateCoinRates", {
            rewards: changedRewards,
            user: this.user,
            currency: this.bulkUpdateCurrency,
            new_rate: this.bulkNewRate
          });
          
          this.$message({
            type: "success",
            message: `Successfully updated ${changedRewards.length} reward(s)`
          });
          
          this.closeBulkUpdateModal();
          
          await this.$store.dispatch("reward/patchRewardsInCatalog", changedRewards.map((reward) => ({
            key: reward.key,
            partial: {
              coins: reward.newCoins,
              updateby: this.user.email,
              updatetime: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            },
          })));
        } catch (error) {
          console.error("Error applying bulk update:", error);
          this.$message({
            type: "error",
            message: "Failed to update rewards. Please try again."
          });
        } finally {
          this.bulkUpdateLoading = false;
        }
      }).catch(() => {
        // User cancelled
      });
    }
  },
};
</script>
<style lang="scss" scoped>
#rewards {
  font-family: Lato, 'Kanit', Arial, sans-serif;
}
.scroll-style {
  max-height: 58vh;
  padding-bottom: 1px;
}
.bg-activity {
  background-color: rgba(#6c30cc, 0.05);
}
.button-quantity {
  width: 94px;
  height: 40px;
  font-size: 18px;
  padding-top: 4px;
  background-color: #d0d0d0;
}

/* === Unified limit-mode picker (Unlimited / Total / Monthly) === */
.limit-mode-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.limit-mode-picker {
  display: inline-flex;
  align-items: stretch;
  background: #f1eef6;
  padding: 4px;
  border-radius: 999px;
  gap: 2px;
  width: fit-content;
  border: 1px solid rgba(108, 48, 204, 0.08);
}
.limit-mode-pill {
  border: 0;
  background: transparent;
  padding: 9px 18px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: #6b6b7d;
  cursor: pointer;
  transition: color 160ms ease, background-color 200ms ease, box-shadow 200ms ease, transform 120ms ease;
  white-space: nowrap;
  outline: none;
}
.limit-mode-pill:hover {
  color: #1a1a2e;
}
.limit-mode-pill:focus-visible {
  outline: 2px solid rgba(108, 48, 204, 0.4);
  outline-offset: 2px;
}
.limit-mode-pill.is-active {
  background: linear-gradient(135deg, #6c30cc 0%, #8a4cd9 100%);
  color: #ffffff;
  box-shadow: 0 1px 6px rgba(108, 48, 204, 0.32), 0 1px 2px rgba(108, 48, 204, 0.18);
}
.limit-mode-pill.is-active:hover {
  color: #ffffff;
}
.limit-value-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: #fafafd;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  flex-wrap: wrap;
}
.limit-value-display {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  min-width: 0;
}
.limit-value-num {
  font-size: 28px;
  font-weight: 800;
  color: #1a1a2e;
  letter-spacing: -0.02em;
  line-height: 1;
  min-width: 36px;
}
.limit-value-unit {
  font-size: 12px;
  font-weight: 600;
  color: #95989a;
  letter-spacing: 0.02em;
  white-space: nowrap;
  text-transform: lowercase;
  flex-shrink: 0;
}
.limit-value-controls {
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
  gap: 6px;
}
.limit-value-controls .button-quantity {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  font-size: 16px;
  padding: 0;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: #1a1a2e;
  transition: background 140ms ease, border-color 140ms ease, transform 80ms ease;
}
.limit-value-controls .button-quantity.mr-12 {
  margin-right: 0;
}
.limit-value-controls .button-quantity:hover {
  background: #f5f0ff;
  border-color: rgba(108, 48, 204, 0.3);
}
.limit-value-controls .button-quantity:active {
  transform: scale(0.94);
}
.limit-helper-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b6b7d;
  padding-left: 4px;
  white-space: normal;
  line-height: 1.45;
}
.limit-helper-icon {
  font-size: 13px;
  color: #6c30cc;
}
.limit-fade-enter-active,
.limit-fade-leave-active {
  transition: opacity 200ms ease, transform 240ms cubic-bezier(0.4, 0, 0.2, 1);
}
.limit-fade-enter,
.limit-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
.txtOptioRedeemed {
  color: #4a4a4a;
  font-size: 16px;
  margin-left: 16px;
}
.divTitle {
  width: 70px;
  height: 50px;
  background: #dbdbdb;
}
.divDescribe {
  margin-left: 32px;
  margin-top: 14px;
}
.divContentReward {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.inputSearchStyle {
  width: 320px;
  margin-left: 48px;
  margin-top: 35px;
}
.menuOptionStyle {
  background: #f4f4f4;
  border-bottom: transparent;
  border-radius: 4px;
  margin-top: 35px;
  margin-right: 48px;
}
.menuOptionStyleRedeemed {
  border: 1px solid;
  width: 200px;
  border-color: #c7c7c7;
  border-radius: 4px;
  height: 48px;
}
.divTable {
  flex: 1;
  margin-left: 48px;
  margin-right: 48px;
}
.img-rewards {
  width: 70px;
  height: 45px;
  object-fit: cover;
}
.button {
  width: 95px;
  font-size: 13px;
  font-weight: 700;
}
.buttonEdit {
  width: 66px;
  height: 42px;
  font-size: 15px;
  font-weight: 700;
  border-radius: 8px;
}
.buttonTitle {
  margin-left: 15px;
  font-weight: 700;
  font-size: 18px;
  width: 160px;
  height: 52px;
  background: #32c2d5;
  border: 1px solid #32c2d5;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(50, 194, 213, 0.25);
}
.buttonRedeemed {
  margin-left: 24px;
  font-weight: 700;
  font-size: 18px;
  height: 52px;
  width: 132px;
  border-radius: 8px;
}
.avatar-uploader,
.avatar-uploader-error {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  height: 200px;
  background: #e3e3e3;
  border-radius: 2px 2px 0 0;
}
.avatar-uploader-error {
  border-style: solid;
  border-color: #f56c6c;
}
.div-uploader-error {
  text-align: center;
  margin: 10px 0 0 0;
  color: #f56c6c;
  font-size: 12px;
}
.avatar-uploader-icon {
  width: 130px;
  height: 70px;
  margin: 80px 50px 50px 50px;
}
.avatar {
  width: 375px;
  height: 192px;
  display: block;
}
.dialogLabel {
  font-size: 18px;
  font-weight: 700;
  text-align: right;
  color: #4a4a4a;
}
.dialogInput {
  width: 90%;
}
.dialogInput2 {
  width: 97%;
}
.btnCancelDialog {
  min-width: 98px;
  height: 36;
  padding: 0 16px;
  white-space: nowrap;
  font-weight: 700;
  font-size: 13px;
  border-radius: 8px;
}
.btnSaveDialog {
  min-width: 80px;
  height: 36;
  padding: 0 16px;
  white-space: nowrap;
  font-weight: 700;
  font-size: 13px;
  color: #ffffff;
  background: #32c2d5;
  border: 1px solid #32c2d5;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(50, 194, 213, 0.25);
}
.btnSaveDialog:hover {
  background: #32c2d5;
  opacity: 0.8;
  border: 1px solid #32c2d5;
}
.btnDeleteDialog {
  font-size: 15px;
  font-weight: 700;
  height: 50px;
  padding: 9px 25px;
  color: #ffffff;
  background: #f44336;
  border: 1px solid #f44336;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(244, 67, 54, 0.25);
}
.btnDeleteDialog:hover {
  background: #f44336;
  opacity: 0.8;
  border: 1px solid #f44336;
  color: #ffffff;
}
.el-button--primary {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
}
.el-button--primary:hover,
.el-button--primary:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}
.el-button--primary:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}
.viewButtonFooter {
  margin-top: 30px;
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-end;
  margin-right: 12px;
}
.grid-2-section {
  display: grid;
  grid-template-columns: 400px auto;
}
.grid-left {
  background-color: #977bbe;
  .header {
    background-color: #6c30cc;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    padding: 18px 40px;
  }
  .body {
    bottom: 0;
    position: absolute;
    width: 400px;
    .image-container {
      background-color: #977bbe;
      padding-top: 32px;
    }
    .image-box {
      border-radius: 32px 32px 0 0;
      background-color: #d6d6d6;
    }
    .details {
      background-color: #FFFFFF;
      padding: 16px 24px 0 24px;
    }
    .avatar-uploader,
    .avatar-uploader-error {
      cursor: pointer;
      position: relative;
      overflow: hidden;
      text-align: center;
      height: 192px;
      background: #e3e3e3;
      border-radius: 2px 2px 0 0;
    }
    .avatar-uploader-error {
      border-style: solid;
      border-color: #f56c6c;
    }
    .div-uploader-error {
      text-align: center;
      margin: 10px 0 0 0;
      color: #f56c6c;
      font-size: 12px;
    }
    .avatar-uploader-icon {
      width: 130px;
      height: 70px;
      margin: 0;
    }
    .avatar {
      border-radius: 32px 32px 0 0;
      display: block;
      width: 100%;
    }
    .button-take-reward {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.15);
    }
    .button-redeem {
      background-color: #00cfe8;
      width: 247px;
      height: 36px;
      margin-left: 16px;
      padding: 12px 8px;
      border-radius: 6px;
      color: #fff;
      font-size: 19px;
      box-shadow: 0px 2px #006064;
      > .mock {
        background-color: #00a3b7;
        border-radius: 7px;
        padding: 8px 12px;
        margin-left: 32px;
        > .coin {
          width: 22px;
          height: 22px;
        }
      }
    }
    .button-cencel-redeem {
      width: 65px;
      height: 60px;
      border-radius: 6px;
      color: #747474;
      font-size: 30px;
      font-weight: 900;
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
}
.grid-right {
  padding: 32px 64px 32px 32px;
  background-color: #f8f8f8;
  .button-upload {
    background-color: #6c30cc;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    width: 120px;
    height: 44px;
  }
  .button-upload.button-disable {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: default;
  }
  .dialogLabel {
    font-size: 16px;
    font-weight: 700;
    color: #4a4a4a;
  }
}
.btn-add.disable {
  font-size: 15px;
  font-weight: 700;
  height: 50px;
  padding: 9px 32px;
  opacity: 0.5;
  cursor: default;
}
.btn-cancel {
  background-color: #747474;
}
.recipient-user-box {
  padding: 4px 0;
}
.btn-export {
  min-width: 100px;
  height: 40px;
  padding: 0 16px;
  white-space: nowrap;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
}
// Bulk Update Link Style
.bulk-update-link {
  color: #6c30cc;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    color: #8b5cf6;
    text-decoration: underline;
  }
  i {
    margin-right: 4px;
  }
}
// Bulk Update Modal Styles
.bulk-update-content {
  padding: 0;
}
.bulk-settings-row {
  display: flex;
  gap: 32px;
  align-items: flex-end;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.bulk-setting-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.bulk-label {
  font-size: 13px;
  font-weight: 600;
  color: #666;
}
.bulk-rate-display {
  font-size: 15px;
  color: #333;
  padding: 8px 0;
}
.bulk-rate-input {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #333;
  .el-input {
    width: 100px;
  }
}
.bulk-preview-section {
  margin-bottom: 16px;
}
.bulk-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.bulk-preview-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bulk-preview-count {
  font-size: 13px;
  color: #999;
}
.bulk-filter-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  user-select: none;
}
.bulk-preview-table {
  max-height: 380px;
  overflow-y: auto;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }
  
  thead {
    position: sticky;
    top: 0;
    background: #fafafa;
    z-index: 1;
  }
  
  th {
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #e4e7ed;
  }
  
  td {
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
  }
  
  tr:last-child td {
    border-bottom: none;
  }
  
  tr:hover td {
    background: #fafafa;
  }
  
  .col-name {
    width: 40%;
  }
  .col-value, .col-current, .col-new, .col-change {
    width: 15%;
    text-align: right;
  }
  th.col-value, th.col-current, th.col-new, th.col-change {
    text-align: right;
  }
  
  .reward-name {
    display: block;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .coin-input {
    width: 90px;
    .el-input__inner {
      text-align: right;
    }
  }
  
  .change-positive {
    color: #35D077;
    font-weight: 500;
  }
  .change-negative {
    color: #f56c6c;
    font-weight: 500;
  }
  .change-none {
    color: #999;
  }
}
.bulk-empty-state {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 14px;
}

.gem-exchange-banner {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 28px;
  padding: 22px 26px;
  border-radius: 16px;
  background: #fafafe;
  border: 1px solid #eef0f5;
  transition: all 200ms ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -40%;
    right: -10%;
    width: 220px;
    height: 220px;
    background: radial-gradient(circle, rgba(108, 48, 204, 0.05) 0%, transparent 70%);
    pointer-events: none;
    opacity: 0;
    transition: opacity 240ms ease;
  }

  &.is-enabled {
    background: linear-gradient(100deg, rgba(108, 48, 204, 0.05) 0%, rgba(59, 130, 246, 0.04) 50%, rgba(245, 158, 11, 0.04) 100%);
    border-color: rgba(108, 48, 204, 0.22);

    &::before { opacity: 1; }
  }

  &.is-configured {
    background: linear-gradient(100deg, rgba(108, 48, 204, 0.08) 0%, rgba(59, 130, 246, 0.05) 50%, rgba(245, 158, 11, 0.06) 100%);
    border-color: rgba(108, 48, 204, 0.28);
    box-shadow: 0 4px 16px rgba(108, 48, 204, 0.08);
  }

  .geb-icon {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(108, 48, 204, 0.16), 0 1px 3px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    position: relative;
    z-index: 1;

    img {
      width: 48px;
      height: 48px;
      object-fit: contain;
    }
  }

  .geb-copy {
    flex: 1;
    min-width: 0;
    position: relative;
    z-index: 1;
  }

  .geb-title {
    font-size: 18px;
    font-weight: 800;
    color: #1a1a2e;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    letter-spacing: -0.01em;
  }

  .geb-pill {
    display: inline-flex;
    align-items: center;
    padding: 3px 11px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    background: rgba(108, 48, 204, 0.14);
    color: #6C30CC;
    line-height: 1.5;

    &.geb-pill-warn {
      background: rgba(247, 185, 36, 0.22);
      color: #B45309;
    }

    &.geb-pill-muted {
      background: #f0f0f6;
      color: #8e8ea8;
    }
  }

  .geb-sub {
    font-size: 14px;
    color: #5a5a7a;
    margin-top: 4px;
    line-height: 1.5;
  }

  .geb-cta {
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    font-weight: 600;
  }
}

.linked-gem-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 7px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #efe8fb;
  color: #6c30cc;
  font-size: 11px;
  font-weight: 700;
  vertical-align: 2px;
}

.linked-gem-entry {
  clear: both;
  padding-top: 12px;
}

.linked-gem-entry-button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 11px 13px;
  border: 1px solid #d9c8f4;
  border-radius: 9px;
  background: #faf8fe;
  color: #4d2b7f;
  text-align: left;
  cursor: pointer;
  transition: border-color 160ms ease, background-color 160ms ease;
}

.linked-gem-entry-button:hover {
  border-color: #8a4cd9;
  background: #f6f0ff;
}

.linked-gem-entry-button img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.linked-gem-entry-button span {
  display: flex;
  flex: 1;
  flex-direction: column;
  line-height: 1.3;
}

.linked-gem-entry-button strong {
  font-size: 13px;
}

.linked-gem-entry-button small {
  margin-top: 2px;
  color: #84788f;
  font-size: 11px;
}

.managed-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  margin-right: 8px;
  border-radius: 4px;
  background: rgba(108, 48, 204, 0.1);
  color: #6C30CC;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  vertical-align: middle;

  i { font-size: 11px; }
}
</style>
<style lang="scss">
#hide-arrow-menu {
  background-color: transparent;
  height: 24px;
  width: 24px;
  .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  .el-submenu__title {
    height: 24px;
    width: 24px;
  }
}
#rewards .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#rewards .el-tabs__header {
  margin: 0px;
}
#rewards > div.el-dialog__wrapper > div > div.el-dialog__header {
  padding: 0px !important;
  padding-bottom: 0px !important;
}
#rewards table {
  border-color: unset;
}
#rewards .el-tabs__content {
  border: none;
}
#redeemedTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .is-leaf
  > div {
  font-weight: 700;
  font-size: 14px;
}
#redeemedTable > div.is-scrolling-none > table > tbody > tr > td > div {
  font-size: 13px;
}
#redeemedTable
  > div.is-scrolling-none
  > table
  > tbody
  > tr
  > .el-table_3_column_13
  > div {
  font-weight: bold;
  font-size: 13px;
}
#rewards > div:nth-child(3) > div > div.el-dialog__body > div.divTable {
  margin-left: 30px;
  margin-right: 16px;
}
#rewards > div:nth-child(3) > div {
  height: 680px;
  width: 820px;
}
#rewards > div:nth-child(3) > div > div.el-dialog__body {
  padding: 0px 0px 0px 0px;
}
#redeemedTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr:nth-child(1)
  > td.el-table_3_column_13 {
  padding: 0px 0px 0px 0px;
}
#redeemedTable .el-table__body-wrapper {
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 4px;
  }
}
#rewards > div:nth-child(3) {
  overflow: hidden;
}
#rewards .el-menu--horizontal > .el-menu-item {
  color: rgba(0, 0, 0, 0.62);
  font-size: 18px;
  font-weight: 400;
  height: 52px;
}
#rewards .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}
#rewards .el-menu--horizontal > .el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}
#rewards .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 8px;
}
#rewards .el-dialog__header {
  padding-top: 32px;
  padding-left: 32px;
  padding-bottom: 0px;
}
/* Making the close button the same size across different modal windows */
#rewards i.el-dialog__close.el-icon.el-icon-close {
  font-size: 32px;
  color: #979797;
  margin-top: 6px;
  margin-right: 12px;
}
#enabledInstant span.el-switch__core {
  height: 14px;
  width: 34px !important;
  border: none;
}
#enabledInstant span.el-switch__core::after {
  background: #32c2d5;
  width: 20px;
  height: 20px;
  margin-top: -4px;
  position: absolute;
  left: -1px;
}
#enabledInstant .el-switch.is-checked .el-switch__core::after {
  margin-left: 17px;
}

#rewards #reward_form_modal {
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-menu {
    background-color: transparent;
  }
  .dialogInput {
    width: 100%;
  }
  .el-date-editor .el-range-separator {
    width: 6%;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__error {
    font-size: 10px;
    padding-top: 0px;
  }
}
// Bulk Update Dialog Styles
#rewards .el-dialog.bulk-update-dialog {
  border-radius: 8px;
}
#rewards .el-dialog.bulk-update-dialog .el-dialog__header {
  padding: 24px 32px 20px 32px !important;
  border-bottom: 1px solid #eee;
}
#rewards .el-dialog.bulk-update-dialog .el-dialog__body {
  padding: 24px 32px !important;
}
#rewards .el-dialog.bulk-update-dialog .el-dialog__footer {
  padding: 16px 32px 24px 32px !important;
  border-top: 1px solid #eee;
}
// Inherits the global 12px radius from element-variables.scss.
// (Previously hard-set 32px, which reads too rounded against the new
// chrome. The bulk-update-dialog keeps its bespoke 8px above.)
#rewards .el-dialog {
  overflow: hidden;
}

/* Cosmetic polish for the Add/Edit Reward dialog. Scoped to .rw-modal
 * so it cannot bleed into other dialogs. */
.el-dialog.rw-modal {
  .el-input__inner,
  .el-textarea__inner {
    border: 1px solid #e2e4ea;
    border-radius: 10px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  .el-input__inner:focus,
  .el-textarea__inner:focus {
    border-color: #6c30cc;
    box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.12);
  }

  .btn-add.bigger {
    background-color: #6c30cc;
    border-color: #6c30cc;
    border-radius: 10px;
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
  }
  .btn-add.bigger:hover,
  .btn-add.bigger:focus {
    background-color: #5a25b0;
    border-color: #5a25b0;
    box-shadow: 0 6px 16px rgba(108, 48, 204, 0.18);
  }

  .btn-cancel.bigger {
    background-color: transparent;
    border: 1px solid #e2e4ea;
    color: #4a4a4a;
    border-radius: 10px;
    transition: background-color 0.15s ease;
  }
  .btn-cancel.bigger:hover,
  .btn-cancel.bigger:focus {
    background-color: #f7f8fb;
  }

  .el-switch.is-checked .el-switch__core {
    background-color: #6c30cc;
    border-color: #6c30cc;
  }

  /* Kill every inline `margin-left: -55px` wrapper (4 of them) that pulls
   * labels into the preview panel and clips them, and the inline `146px`
   * on the language menu that pushed Bahasa Malaysia onto a second row.
   * Also catches the `145px` shift further down. Labels + language bar
   * now sit inside the form panel. */
  .grid-right [style*="margin-left: -55px"],
  .grid-right [style*="margin-left:-55px"] {
    margin-left: 0 !important;
  }
  .grid-right [style*="margin-left: 145px"],
  .grid-right [style*="margin-left:145px"] {
    margin-left: 0 !important;
  }
  /* Language menu — restyle the el-menu horizontal tabs into the same
   * chip/pill treatment used in the Add/Edit Question modal's aq-lang-tabs
   * so language selection reads consistently across the app. */
  .grid-right .el-menu-demo {
    margin-left: 0 !important;
    border-bottom: 0 !important;
    background: transparent !important;
    display: flex;
    gap: 6px;
    padding: 0;
    margin-bottom: 20px;
  }
  .grid-right .el-menu-demo .el-menu-item {
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 12px !important;
    border-radius: 999px !important;
    border-bottom: 0 !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    letter-spacing: 0.03em;
    color: #8a8a8a !important;
    white-space: nowrap;
    transition: background .15s ease, color .15s ease;
  }
  .grid-right .el-menu-demo .el-menu-item:hover,
  .grid-right .el-menu-demo .el-menu-item:focus {
    background: #f7f8fb !important;
    color: #4a4a4a !important;
  }
  .grid-right .el-menu-demo .el-menu-item.is-active {
    background: #f2ecfb !important;
    color: #6c30cc !important;
    border-bottom: 0 !important;
  }

  /* Calm the preview panel's purple header so the 2-pane reads as one
   * card rather than a loud brand strip over a floating reward mock. */
  .grid-left {
    background-color: #efe9fb;
  }
  .grid-left .header {
    background-color: #ffffff;
    color: #2f2f2f;
    font-size: 14px;
    font-weight: 800;
    padding: 16px 24px;
    border-bottom: 1px solid #eef0f5;
  }
  .grid-left .body .image-container {
    background-color: #efe9fb;
  }

  /* Field labels — eyebrow style matching Question Details + Add/Edit
   * Question. Vertically centered with the 40px input; label column
   * tightened from 200px to 140px so short labels don't leave a huge
   * dead zone between label and field. */
  .el-form-item__label {
    width: 140px !important;
    text-align: left !important;
    padding-right: 12px !important;
    padding-bottom: 0 !important;
    line-height: 40px !important;
    height: 40px;
    display: flex;
    align-items: center;
  }
  .el-form-item__content {
    margin-left: 140px !important;
    line-height: 40px;
  }
  .dialogLabel {
    font-size: 11px !important;
    font-weight: 700 !important;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8a8a8a !important;
    white-space: nowrap;
    line-height: 1 !important;
    display: inline-flex;
    align-items: center;
  }
  .dialogLabel .fc-F56C6C {
    color: #6c30cc !important;
    margin-right: 4px;
  }
  /* Textarea's label should anchor to the top of the field (textareas
   * grow beyond 40px), not vertically center against a tall box. */
  .el-form-item:has(.el-textarea) .el-form-item__label {
    align-items: flex-start;
    padding-top: 10px;
  }

  /* Vertical rhythm — tighten the space between form items so related
   * fields read as one group instead of floating in a loose stack. */
  .el-form-item {
    margin-bottom: 14px !important;
  }

  /* Trim the form panel's right padding — 64px created a wide empty
   * gutter. 32px on both sides is still generous and hands the fields
   * more horizontal room. */
  .grid-right {
    padding: 24px 32px 24px 32px !important;
  }

  /* Language pills sit closer to the title now that the form below is
   * tighter overall. */
  .grid-right .el-menu-demo {
    margin-bottom: 14px;
  }
}

.el-dialog.ra-modal {
  width: calc(100vw - 64px) !important;
  max-width: calc(100vw - 32px);
  max-width: 1480px;
  height: calc(100vh - 48px);
  min-height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
  flex-shrink: 0;
  margin-top: 24px !important;
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(17, 24, 39, 0.14);

  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
  .el-dialog__headerbtn {
    top: 22px;
    right: 26px;
    z-index: 3;
  }
  .el-dialog__close {
    color: #9aa0ac;
    font-size: 18px;
    transition: color 0.15s ease;
  }
  .el-dialog__close:hover {
    color: #4a4a4a;
  }

  .ra-modal-shell,
  .ra-modal-content {
    height: 100%;
    min-height: 0;
  }
  .ra-modal-content {
    display: flex;
    flex-direction: column;
  }

  .ra-loading-state {
    height: 100%;
    padding: 34px 40px 30px;
    box-sizing: border-box;
    background: #ffffff;
  }
  .ra-loading-message {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 28px;
    color: #1a1a1a;
  }
  .ra-loading-message .el-icon-loading {
    color: #6c30cc;
    font-size: 28px;
  }
  .ra-loading-title {
    font-size: 17px;
    font-weight: 800;
  }
  .ra-loading-hint {
    margin-top: 4px;
    color: #6b7280;
    font-size: 13px;
    font-weight: 500;
  }
  .ra-loading-preview {
    opacity: 0.9;
  }
  .ra-loading-summary,
  .ra-loading-stat-group,
  .ra-loading-toolbar,
  .ra-loading-row {
    display: flex;
    align-items: center;
  }
  .ra-loading-summary {
    justify-content: space-between;
    gap: 32px;
  }
  .ra-loading-stat-group {
    gap: 10px;
  }
  .ra-skeleton {
    display: block;
    height: 12px;
    border-radius: 7px;
    background: linear-gradient(90deg, #f1f2f6 25%, #e7e9ef 38%, #f1f2f6 63%);
    background-size: 400% 100%;
    animation: reward-activity-skeleton 1.4s ease infinite;
  }
  .ra-skeleton-heading {
    width: 220px;
    height: 52px;
    border-radius: 12px;
  }
  .ra-skeleton-stat {
    width: 110px;
    height: 64px;
    border-radius: 12px;
  }
  .ra-loading-chart {
    height: 180px;
    margin: 22px 20px 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 18px;
  }
  .ra-skeleton-bar {
    width: 42px;
    height: 58%;
    border-radius: 8px 8px 4px 4px;
  }
  .ra-skeleton-bar:nth-child(3n + 1) { height: 42%; }
  .ra-skeleton-bar:nth-child(3n + 2) { height: 70%; }
  .ra-loading-toolbar {
    gap: 12px;
    padding: 24px 0 18px;
    border-top: 1px solid #eef0f5;
  }
  .ra-skeleton-control {
    width: 200px;
    height: 40px;
    border-radius: 10px;
  }
  .ra-skeleton-toggle {
    width: 220px;
    height: 40px;
    border-radius: 8px;
  }
  .ra-loading-table {
    border-top: 1px solid #eef0f5;
  }
  .ra-loading-row {
    gap: 40px;
    min-height: 54px;
    border-bottom: 1px solid #f3f4f7;
  }
  .ra-loading-row .ra-skeleton:nth-child(1) { width: 24%; }
  .ra-loading-row .ra-skeleton:nth-child(2) { width: 14%; }
  .ra-loading-row .ra-skeleton:nth-child(3) { width: 12%; }
  .ra-loading-row .ra-skeleton:nth-child(4) { width: 20%; }
  .ra-loading-row .ra-skeleton:nth-child(5) { width: 18%; }

  .ra-error-state {
    height: 100%;
    padding: 48px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #ffffff;
  }
  .ra-error-state > i {
    margin-bottom: 18px;
    color: #6c30cc;
    font-size: 38px;
  }
  .ra-error-title {
    color: #1a1a1a;
    font-size: 19px;
    font-weight: 800;
  }
  .ra-error-hint {
    max-width: 440px;
    margin: 8px 0 22px;
    color: #6b7280;
    font-size: 13px;
    line-height: 1.55;
  }

  .ra-hero {
    flex-shrink: 0;
    position: relative;
    background: #ffffff;
    padding: 24px 40px 16px;
    border-bottom: 1px solid #eef0f5;
  }
  .ra-hero-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    padding-right: 40px;
    margin-bottom: 12px;
  }
  .ra-eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #8a8a8a;
    margin-bottom: 10px;
  }
  .ra-hero-title {
    font-family: Lato, 'Kanit', Arial, sans-serif;
    font-size: 30px;
    font-weight: 900;
    color: #1a1a1a;
    line-height: 1;
    letter-spacing: -0.015em;
  }
  .ra-hero-sub {
    margin-top: 8px;
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
  }
  .ra-hero-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
  }
  .ra-refreshing {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    color: #6c30cc;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }
  .ra-hero-stats {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
  }
  .ra-stat {
    min-width: 84px;
    padding: 12px 14px 10px;
    background: #ffffff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(17, 24, 39, 0.03);
  }
  .ra-stat-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #8a8a8a;
    margin-bottom: 4px;
  }
  .ra-stat-value {
    font-size: 18px;
    font-weight: 800;
    color: #1a1a1a;
    line-height: 1;
  }
  .ra-chart-wrap {
    height: 128px;
    margin: 0 -4px;
  }

  .ra-toolbar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 40px 12px;
    background: #ffffff;
  }
  .ra-month-picker {
    width: 200px;
    flex-shrink: 0;
  }
  .ra-month-picker .el-menu.el-menu--horizontal {
    border-bottom: 0 !important;
    background: transparent;
  }
  .ra-month-picker .el-submenu {
    width: 100% !important;
  }
  .ra-month-picker .el-submenu__title {
    position: relative;
    height: 40px !important;
    line-height: 40px !important;
    padding: 0 36px 0 14px !important;
    background: #f7f8fb !important;
    border: 1px solid #e2e4ea !important;
    border-radius: 10px !important;
    color: #2f2f2f !important;
    font-size: 14px;
    font-weight: 600;
    transition: border-color 0.15s ease, background 0.15s ease;
  }
  .ra-month-picker .el-submenu__title:hover {
    background: #f1f2f7 !important;
    border-color: #d6d9e0 !important;
  }
  // Element UI's default icon-arrow doesn't paint reliably inside a
  // horizontal-mode submenu, so we hide it and draw a CSS chevron below.
  .ra-month-picker .el-submenu__icon-arrow {
    display: none !important;
  }
  .ra-month-picker .el-submenu__title::after {
    content: '';
    position: absolute;
    right: 14px;
    top: 50%;
    width: 8px;
    height: 8px;
    margin-top: -6px;
    border-right: 2px solid #8a8a8a;
    border-bottom: 2px solid #8a8a8a;
    transform: rotate(45deg);
    transition: transform 0.2s ease, margin-top 0.2s ease, border-color 0.15s ease;
  }
  .ra-month-picker .el-submenu__title:hover::after {
    border-color: #6c30cc;
  }
  .ra-month-picker .el-submenu.is-opened .el-submenu__title::after {
    transform: rotate(-135deg);
    margin-top: -2px;
    border-color: #6c30cc;
  }
  .ra-month-picker .text-dropdown {
    color: #2f2f2f;
    font-weight: 600;
    font-size: 14px;
  }

  .ra-month-picker .el-menu--popup {
    min-width: 200px !important;
    padding: 6px !important;
    border: 1px solid #eef0f5 !important;
    border-radius: 12px !important;
    box-shadow:
      0 12px 32px rgba(17, 24, 39, 0.1),
      0 2px 6px rgba(17, 24, 39, 0.04) !important;
    background: #ffffff !important;
    margin-top: 6px !important;
  }
  .ra-month-picker .el-menu--popup .scroll-style {
    max-height: 320px;
    overflow-y: auto;
    padding-right: 2px;
  }
  .ra-month-picker .el-menu--popup .el-menu-item {
    height: 34px !important;
    line-height: 34px !important;
    padding: 0 12px !important;
    margin: 1px 0 !important;
    border-radius: 8px !important;
    font-size: 13px;
    font-weight: 600;
    color: #4a4a4a !important;
    background: transparent !important;
    transition: background 0.12s ease, color 0.12s ease;
  }
  .ra-month-picker .el-menu--popup .el-menu-item:hover,
  .ra-month-picker .el-menu--popup .el-menu-item:focus {
    background: #f2ecfb !important;
    color: #6c30cc !important;
  }
  .ra-month-picker .el-menu--popup .el-menu-item.is-active {
    background: #f2ecfb !important;
    color: #6c30cc !important;
  }

  .ra-export-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 18px;
    border-radius: 10px;
    background: #6c30cc;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
    cursor: pointer;
    margin-left: auto;
    box-shadow: 0 1px 2px rgba(108, 48, 204, 0.18);
    transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  }
  .ra-export-btn:hover {
    background: #5a25b0;
    box-shadow: 0 6px 16px rgba(108, 48, 204, 0.22);
    transform: translateY(-1px);
  }
  .ra-export-btn:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(108, 48, 204, 0.18);
  }

  .ra-view-toggle {
    display: inline-flex;
    flex-shrink: 0;
  }
  .ra-view-toggle .el-radio-button__inner {
    height: 40px;
    padding: 0 16px;
    border-color: #e2e4ea;
    color: #626262;
    font-size: 13px;
    font-weight: 700;
    line-height: 38px;
    box-shadow: none;
  }
  .ra-view-toggle .el-radio-button__inner:hover {
    color: #522698;
  }
  .ra-view-toggle .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #6c30cc;
    border-color: #6c30cc;
    color: #ffffff;
    box-shadow: -1px 0 0 0 #6c30cc;
  }

  // The el-table owns the scroll via :max-height, so this wrapper must
  // never clip — nested scroll containers fight each other and cut the
  // last rows off the table.
  .ra-table-wrap {
    flex: 1;
    min-height: 0;
    padding: 0 28px 20px 40px;
  }
  .ra-table-wrap .el-table {
    background: transparent;
    font-family: Lato, 'Kanit', Arial, sans-serif;
  }
  .ra-table-wrap .el-table::before {
    display: none;
  }
  .ra-table-wrap .el-table th.el-table__cell {
    background: transparent !important;
    border-bottom: 1px solid #eef0f5 !important;
    padding: 10px 0 !important;
  }
  .ra-table-wrap .el-table th.el-table__cell > .cell {
    font-size: 10px !important;
    font-weight: 800 !important;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #9aa0ac !important;
    padding: 0 12px;
  }
  .ra-table-wrap .el-table td.el-table__cell {
    border-bottom: 1px solid #f3f4f7 !important;
    padding: 8px 0 !important;
  }
  .ra-table-wrap .el-table td.el-table__cell > .cell {
    padding: 0 12px;
    color: #1a1a1a;
  }
  .ra-table-wrap .el-table tbody tr:hover > td.el-table__cell {
    background: #fafbfd !important;
  }
  .ra-table-wrap .recipient-user-box {
    padding: 0 !important;
  }
  .ra-table-wrap .recipient-user-box .image-profile-32,
  .ra-table-wrap .recipient-user-box .image-skeleton.image-profile-32 {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px;
  }
  .ra-table-wrap .recipient-user-box .text-in-image-32 {
    width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    font-size: 11px !important;
  }
  .ra-table-wrap .el-table .recipient-user-box .fs-14 {
    font-weight: 700 !important;
    color: #1a1a1a;
    line-height: 1.3 !important;
  }
  .ra-table-wrap .el-table .recipient-user-box .fs-13 {
    color: #8a8a8a;
    opacity: 1 !important;
    font-weight: 500;
    font-size: 12px !important;
    line-height: 1.3 !important;
  }

  .ra-member-spend-intro {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;
    padding: 4px 12px 12px;
  }
  .ra-member-spend-title {
    color: #1a1a1a;
    font-size: 15px;
    font-weight: 800;
  }
  .ra-member-spend-hint {
    margin-top: 4px;
    color: #6b7280;
    font-size: 12px;
    font-weight: 500;
  }
  .ra-currency-note {
    color: #6c30cc;
    font-size: 11px;
    font-weight: 700;
    text-align: right;
  }
  .ra-share-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #4a4a4a;
    font-size: 12px;
    font-weight: 700;
  }
  .ra-share-track {
    width: 118px;
    height: 6px;
    overflow: hidden;
    border-radius: 999px;
    background: #eee9f5;
  }
  .ra-share-fill {
    height: 100%;
    border-radius: inherit;
    background: #6c30cc;
  }
  .ra-last-activity {
    white-space: nowrap;
  }

  .ra-table-wrap .span-status-tag {
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 12px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1;
    white-space: nowrap;
  }
  .ra-table-wrap .span-status-tag.tag-delivered {
    background: #e6f6ee !important;
    color: #0f8a4c !important;
  }
  .ra-table-wrap .span-status-tag.tag-processing {
    background: #fff3db !important;
    color: #a06900 !important;
  }
  .ra-table-wrap .span-status-tag.tag-cancel {
    background: #fbe9ec !important;
    color: #b12c3b !important;
  }
  .ra-table-wrap .span-status-tag.tag-refund {
    background: #ecebfa !important;
    color: #5738a8 !important;
  }

  .ra-table-wrap .el-dropdown .el-dropdown-link img {
    opacity: 0.35;
    transition: opacity 0.15s ease;
  }
  .ra-table-wrap tr:hover .el-dropdown .el-dropdown-link img {
    opacity: 0.75;
  }
  .ra-table-wrap .el-dropdown .el-dropdown-link:hover img {
    opacity: 1;
  }

  // Zero the empty dialog footer — Element UI adds 10px margins by default.
  .el-dialog__footer {
    padding: 0 !important;
  }

  @media (max-width: 720px) {
    .ra-modal-content {
      overflow-y: auto;
    }
    .ra-loading-state {
      padding: 28px 24px;
      overflow-y: auto;
    }
    .ra-loading-stat-group {
      display: none;
    }
    .ra-loading-chart {
      gap: 8px;
      margin-left: 0;
      margin-right: 0;
    }
    .ra-skeleton-bar {
      min-width: 12px;
    }
    .ra-hero {
      padding: 28px 24px 20px;
    }
    .ra-hero-head {
      flex-direction: column;
      gap: 16px;
      padding-right: 0;
    }
    .ra-hero-stats {
      width: 100%;
      justify-content: space-between;
    }
    .ra-toolbar {
      flex-wrap: wrap;
      padding: 14px 24px 10px;
    }
    .ra-view-toggle {
      order: 3;
      width: 100%;
    }
    .ra-view-toggle .el-radio-button {
      width: 50%;
    }
    .ra-view-toggle .el-radio-button__inner {
      width: 100%;
    }
    .ra-member-spend-intro {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }
    .ra-currency-note {
      text-align: left;
    }
    .ra-table-wrap {
      padding: 0 12px 20px 24px;
    }
  }
}

@keyframes reward-activity-skeleton {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}

@media (prefers-reduced-motion: reduce) {
  .el-dialog.ra-modal .ra-skeleton {
    animation: none;
  }
}
</style>
